import { useTheme } from '@emotion/react';
import {
  Box,
  Grid,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Popover,
  Button,
  Dialog,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import Menu from '@mui/material/Menu';
import { styled } from '@mui/system';
import React, { useEffect, useState, useContext, useRef } from 'react';
import { datacontext } from 'modules/AppLayout/AppLayout';
// import { ReactComponent as ExtendedSetlement } from "assets/icons/ExtendedSetlement.svg";
import CircularProgress from '@mui/material/CircularProgress';
import { getApiCall, postApiCall } from 'api/apiService';
import { ReactComponent as DownArrowIcon } from 'assets/icons/downarrow-icon.svg';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
// import { ReactComponent as File } from "assets/icons/file.svg";
// import { ReactComponent as FileCopy } from "assets/icons/filecopy.svg";
import { ReactComponent as LeftArrow } from 'assets/icons/left-icon.svg';
import { ReactComponent as Location } from 'assets/icons/location.svg';
// import { ReactComponent as Todo } from "assets/icons/todo.svg";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getlistMakeOffer } from 'api/apiService';
import { ReactComponent as Verticalline } from 'assets/icons/verticalline.svg';
import {
  DepositIconColor,
  SignContractColor,
} from 'component/BuyersMarketplace/Marketplaceicons';
import {
  GetBuyerExpandRight,
  OWNERCARD_RIGHT,
  PIPELINE_CATEGORY,
  PIPELINE_REORDERPROPERTY_CATEGORY,
} from 'constant/app.config';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { poppins400, poppins500, menuitemfont } from 'theme/common.style';
import { ExpendedCardDocumentation } from './ExpendedCardDocumentation';
import { RightArrow } from 'component/OwnerCard/OwnerCard';
import moment from 'moment';
import { WarningLite } from 'component/BuyerRegistration/components/WarningLite';
import BadgeButton, {
  getColor,
} from 'component/BuyerRegistration/components/BadgeButton';
import { toast } from 'react-toastify';
import { WindowRounded } from '@mui/icons-material';
import { Pendingwarning } from 'component/BuyersMarketplace/Marketplaceicons';
import Swal from 'sweetalert2';

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import AdditionalConditionTooltip from 'component/Common/AdditionalConditionTooltip';

const ContractFile = () => {
  return (
    <svg
      width="20"
      height="27"
      viewBox="0 0 20 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6891 8.36131C19.6948 7.97098 19.6264 7.5833 19.4879 7.22042C19.3493 6.85754 19.1433 6.52658 18.8815 6.24645L13.8558 0.892349C13.5859 0.609597 13.2647 0.385168 12.9108 0.232011C12.557 0.0788535 12.1774 0 11.794 0H3.66702C2.90374 0 2.17172 0.314951 1.632 0.875566C1.09227 1.43618 0.789063 2.19654 0.789062 2.98937V23.7811C0.789062 24.5739 1.09227 25.3343 1.632 25.8949C2.17172 26.4555 2.90374 26.7705 3.66702 26.7705H16.8111C17.189 26.7705 17.5633 26.6932 17.9125 26.5429C18.2616 26.3927 18.5789 26.1725 18.8461 25.8949C19.1134 25.6173 19.3254 25.2878 19.47 24.9251C19.6146 24.5624 19.6891 24.1737 19.6891 23.7811V8.36131ZM16.8197 6.648H14.1651C14.0767 6.65579 13.9876 6.64478 13.9034 6.61563C13.8193 6.58648 13.7417 6.5398 13.6754 6.47846C13.5546 6.35307 13.4866 6.18295 13.4864 6.00551V3.09645L16.8197 6.648ZM16.8197 24.9858H3.66702C3.51439 24.987 3.36307 24.9566 3.22184 24.8965C3.08062 24.8364 2.95231 24.7477 2.84438 24.6356C2.73646 24.5235 2.65108 24.3902 2.5932 24.2435C2.53532 24.0968 2.5061 23.9396 2.50724 23.7811V2.98937C2.5061 2.83084 2.53532 2.67365 2.5932 2.52696C2.65108 2.38027 2.73646 2.24699 2.84438 2.13489C2.95231 2.02279 3.08062 1.9341 3.22184 1.87398C3.36307 1.81386 3.51439 1.78351 3.66702 1.7847H11.7854V6.00551C11.7854 6.32852 11.8468 6.64836 11.9661 6.94667C12.0853 7.24498 12.2601 7.5159 12.4804 7.74389C12.7007 7.97187 12.9622 8.15245 13.2498 8.27524C13.5374 8.39804 13.8455 8.46065 14.1565 8.45947L17.9709 8.41485V23.7811C17.972 23.9396 17.9428 24.0968 17.8849 24.2435C17.827 24.3902 17.7417 24.5235 17.6337 24.6356C17.5258 24.7477 17.3975 24.8364 17.2563 24.8965C17.1151 24.9566 16.9637 24.987 16.8111 24.9858H16.8197Z"
        fill="#666666"
      />
      <path
        d="M13.6732 10.9219H6.8005C6.57265 10.9219 6.35414 11.0159 6.19303 11.1832C6.03192 11.3506 5.94141 11.5776 5.94141 11.8142C5.94141 12.0509 6.03192 12.2779 6.19303 12.4452C6.35414 12.6126 6.57265 12.7066 6.8005 12.7066H13.6732C13.9011 12.7066 14.1196 12.6126 14.2807 12.4452C14.4418 12.2779 14.5323 12.0509 14.5323 11.8142C14.5323 11.5776 14.4418 11.3506 14.2807 11.1832C14.1196 11.0159 13.9011 10.9219 13.6732 10.9219Z"
        fill="#666666"
      />
      <path
        d="M13.6732 16.749H6.8005C6.57265 16.749 6.35414 16.843 6.19303 17.0104C6.03192 17.1777 5.94141 17.4047 5.94141 17.6414C5.94141 17.878 6.03192 18.105 6.19303 18.2724C6.35414 18.4397 6.57265 18.5337 6.8005 18.5337H13.6732C13.9011 18.5337 14.1196 18.4397 14.2807 18.2724C14.4418 18.105 14.5323 17.878 14.5323 17.6414C14.5323 17.4047 14.4418 17.1777 14.2807 17.0104C14.1196 16.843 13.9011 16.749 13.6732 16.749Z"
        fill="#666666"
      />
    </svg>
  );
};

const moneyicon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_23468_90071)">
        <path
          d="M19.9669 16.0538L18.0952 5.43917C17.9663 4.70812 17.4791 4.10406 16.7919 3.82336L12.3258 1.99903C12.1334 1.92048 11.9331 1.87189 11.7311 1.85185L11.49 0.484316C11.4338 0.165646 11.1301 -0.0470868 10.8113 0.0090457C10.4926 0.0652172 10.2798 0.369122 10.336 0.687792L10.5772 2.05548C10.397 2.14216 10.2278 2.2545 10.0757 2.39145L9.56983 2.84704L9.49483 2.77899C9.34096 2.63938 9.16928 2.52516 8.98639 2.43727L9.29487 0.687792C9.35104 0.369122 9.13827 0.0652172 8.8196 0.0090457C8.50097 -0.0473212 8.19702 0.165607 8.14085 0.484316L7.83234 2.23392C7.63339 2.25376 7.43593 2.30145 7.24617 2.37817L2.73979 4.19929C2.0485 4.47867 1.55847 5.08382 1.42898 5.81815L0.0328525 13.7362C-0.172849 14.9028 0.608943 16.0193 1.77558 16.225L7.48179 17.2312L7.65691 18.2244C7.84046 19.2655 8.74913 20 9.77162 20C9.89502 20 10.0201 19.9893 10.1458 19.9671L18.2242 18.5427C19.3908 18.3369 20.1726 17.2205 19.9669 16.0538ZM18.0207 17.3886L9.94225 18.813C9.68534 18.8583 9.42624 18.8009 9.21253 18.6512C8.99885 18.5016 8.85624 18.2777 8.81093 18.0209L8.70987 17.4477L9.85397 17.6495C9.98002 17.6717 10.1062 17.6827 10.2316 17.6827C10.6683 17.6827 11.0941 17.5493 11.4593 17.2936C11.9294 16.9644 12.2432 16.4719 12.3428 15.9068L13.7396 7.98494C13.8686 7.25385 13.6173 6.51959 13.0675 6.02081L10.442 3.63852L10.8598 3.26227C11.0417 3.09852 11.2774 3.01215 11.5155 3.01215C11.6396 3.01215 11.7645 3.03567 11.8826 3.08391L16.3487 4.90824C16.6611 5.03585 16.8826 5.31038 16.9412 5.64268L18.8128 16.2573C18.9064 16.7876 18.551 17.2951 18.0207 17.3886ZM1.18687 13.9396L2.58307 6.02163C2.64194 5.68784 2.86467 5.41276 3.17889 5.28577L7.60988 3.49508L7.48289 4.21539C7.42672 4.53406 7.63949 4.83796 7.95816 4.89413C7.99257 4.90023 8.02679 4.90312 8.06058 4.90312C8.33956 4.90312 8.58679 4.70308 8.6369 4.41882L8.76397 3.69824L12.2801 6.88865C12.53 7.11537 12.6442 7.44912 12.5856 7.78142L11.1888 15.7033C11.1435 15.9601 11.0009 16.184 10.7872 16.3336C10.5735 16.4832 10.3144 16.5407 10.0575 16.4954L1.97901 15.071C1.44874 14.9774 1.09339 14.4699 1.18687 13.9396Z"
          fill="#10D35E"
        />
        <path
          d="M5.90127 13.6258L5.80771 14.1564C5.77025 14.3688 5.91212 14.5714 6.12458 14.6089C6.14751 14.6129 6.17033 14.6148 6.19287 14.6148C6.37884 14.6148 6.54368 14.4815 6.57708 14.292L6.67583 13.7321C7.07727 13.7308 7.46044 13.6193 7.80043 13.402C8.20516 13.1434 8.51672 12.7512 8.67769 12.2977C9.00543 11.3745 8.6532 10.4592 7.78039 9.96608C7.63618 9.8846 7.50352 9.80753 7.38083 9.73397L7.7711 7.52063C8.04543 7.62168 8.20332 7.78813 8.30844 7.89914C8.33836 7.93074 8.36664 7.96063 8.39555 7.98734C8.55398 8.13379 8.80109 8.12406 8.94754 7.9657C9.09398 7.80731 9.08429 7.56016 8.9259 7.41371C8.91609 7.40465 8.89558 7.38301 8.87578 7.36207C8.73414 7.21243 8.43809 6.89981 7.90801 6.74419L7.98867 6.28661C8.02614 6.07415 7.88426 5.87158 7.6718 5.83412C7.45934 5.79669 7.25676 5.93849 7.2193 6.15099L7.13052 6.65446C7.05005 6.65747 6.96681 6.66349 6.87985 6.6738C6.23677 6.75009 5.68814 7.19282 5.44799 7.82926C5.22971 8.40777 5.31857 9.01742 5.67994 9.42027C5.88158 9.64507 6.14494 9.86472 6.52025 10.1153L6.03693 12.8563C5.65646 12.7686 5.42455 12.6458 5.05252 12.2966C4.89526 12.1489 4.64803 12.1567 4.50038 12.314C4.35272 12.4713 4.36049 12.7185 4.5178 12.8661C5.02416 13.3414 5.39139 13.5122 5.90127 13.6258ZM7.94145 12.0364C7.78903 12.4658 7.38684 12.8811 6.81501 12.9427L7.23602 10.555C7.2879 10.5849 7.34122 10.6153 7.39602 10.6463C8.19895 11.0999 8.01653 11.825 7.94145 12.0364ZM6.2615 8.89859C6.09564 8.71367 6.064 8.40961 6.17892 8.10504C6.28611 7.82094 6.55071 7.49957 6.97184 7.44961C6.97821 7.44887 6.98431 7.44836 6.99063 7.44766L6.67032 9.26425C6.49939 9.13468 6.36587 9.01488 6.2615 8.89859Z"
          fill="#10D35E"
        />
      </g>
      <defs>
        <clipPath id="clip0_23468_90071">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const currency = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7562 4.37505C11.6391 4.3768 11.5265 4.41864 11.4388 4.49299C11.3511 4.56734 11.2942 4.66928 11.2783 4.78032C10.7998 4.9668 10.4571 5.4168 10.4571 5.93755C10.4571 6.30213 10.6411 6.6202 10.8559 6.82561C11.0706 7.03102 11.3077 7.16008 11.5119 7.27727C11.716 7.39446 11.8874 7.49977 11.9789 7.58733C12.0705 7.67489 12.0906 7.70838 12.0906 7.81255C12.0906 7.99069 11.9501 8.12505 11.7639 8.12505C11.5777 8.12505 11.4372 7.99069 11.4372 7.81255C11.4381 7.75043 11.4261 7.68876 11.4019 7.63112C11.3777 7.57348 11.3417 7.52102 11.2961 7.47678C11.2505 7.43255 11.1962 7.39742 11.1363 7.37344C11.0764 7.34947 11.0121 7.33712 10.9471 7.33712C10.8822 7.33712 10.8179 7.34947 10.758 7.37344C10.6981 7.39742 10.6437 7.43255 10.5981 7.47678C10.5525 7.52102 10.5166 7.57348 10.4924 7.63112C10.4682 7.68876 10.4562 7.75043 10.4571 7.81255C10.4571 8.3335 10.8001 8.78343 11.2789 8.96977C11.2955 9.08161 11.3537 9.18398 11.4429 9.25804C11.532 9.3321 11.6461 9.37289 11.7642 9.37289C11.8823 9.37289 11.9964 9.3321 12.0856 9.25804C12.1747 9.18398 12.2329 9.08161 12.2495 8.96977C12.728 8.7833 13.0707 8.3333 13.0707 7.81255C13.0707 7.44796 12.8867 7.1299 12.6719 6.92449C12.4572 6.71908 12.2201 6.59001 12.0159 6.47283C11.8118 6.35564 11.6404 6.25033 11.5489 6.16277C11.4573 6.07521 11.4372 6.04171 11.4372 5.93755C11.4372 5.75941 11.5777 5.62505 11.7639 5.62505C11.9501 5.62505 12.0906 5.75941 12.0906 5.93755C12.0897 5.99966 12.1017 6.06133 12.1259 6.11897C12.1501 6.17662 12.1861 6.22908 12.2317 6.27331C12.2773 6.31755 12.3316 6.35268 12.3915 6.37665C12.4514 6.40063 12.5157 6.41297 12.5807 6.41297C12.6456 6.41297 12.7099 6.40063 12.7698 6.37665C12.8297 6.35268 12.8841 6.31755 12.9297 6.27331C12.9753 6.22908 13.0112 6.17662 13.0354 6.11897C13.0596 6.06133 13.0716 5.99966 13.0707 5.93755C13.0707 5.41659 12.7277 4.96667 12.2489 4.78032C12.2326 4.66688 12.1736 4.56304 12.0829 4.48838C11.9921 4.41372 11.8759 4.37341 11.7562 4.37505Z"
        fill="#2F74EE"
      />
      <path
        d="M11.7605 1.875C8.87934 1.875 6.5332 4.11913 6.5332 6.875C6.5332 7.90282 6.86417 8.90599 7.48141 9.74731C7.51841 9.79773 7.56542 9.84069 7.61977 9.87373C7.67412 9.90677 7.73474 9.92925 7.79818 9.93987C7.86161 9.9505 7.92661 9.94908 7.98946 9.93568C8.05232 9.92228 8.1118 9.89717 8.16451 9.86178C8.21722 9.82639 8.26212 9.78142 8.29666 9.72943C8.3312 9.67744 8.3547 9.61945 8.3658 9.55878C8.37691 9.4981 8.37542 9.43593 8.3614 9.37581C8.34739 9.31568 8.32114 9.25879 8.28414 9.20837C7.78257 8.52472 7.51332 7.7102 7.51332 6.875C7.51332 4.62579 9.40903 2.8125 11.7605 2.8125C14.1119 2.8125 16.0076 4.62579 16.0076 6.875C16.0076 9.12421 14.1119 10.9375 11.7605 10.9375C10.8872 10.9375 10.0352 10.6801 9.3204 10.2002C9.26784 10.1628 9.20798 10.1359 9.14436 10.121C9.08073 10.1061 9.01464 10.1036 8.94997 10.1135C8.88531 10.1235 8.82339 10.1458 8.76787 10.179C8.71235 10.2123 8.66436 10.2558 8.62674 10.3071C8.58912 10.3584 8.56263 10.4164 8.54883 10.4776C8.53503 10.5389 8.53421 10.6021 8.54641 10.6637C8.55861 10.7252 8.58358 10.7838 8.61986 10.836C8.65613 10.8882 8.70297 10.9328 8.7576 10.9674C9.63727 11.558 10.6857 11.875 11.7605 11.875C14.6416 11.875 16.9877 9.63087 16.9877 6.875C16.9877 4.11913 14.6416 1.875 11.7605 1.875Z"
        fill="#2F74EE"
      />
      <path
        d="M1.7967 10.3126C1.52606 10.3126 1.30667 10.5224 1.30664 10.7813V17.6563C1.30667 17.9152 1.52606 18.125 1.7967 18.1251H4.08363C4.35427 18.125 4.57366 17.9152 4.57369 17.6563V12.1876H6.04386C6.19683 12.1876 6.87248 12.441 7.44384 12.7497C8.29296 13.2072 8.55515 13.4174 8.85084 13.4888C9.72864 13.7263 10.9789 13.7072 12.0924 13.874C12.2072 14.0254 12.2522 14.1886 12.2717 14.3751H9.19285C8.53014 14.3661 8.53014 15.3215 9.19285 15.3126H12.8089C13.0754 15.3126 13.2931 15.109 13.299 14.8542C13.2854 13.8929 13.0243 13.0805 12.2359 12.9481C11.0145 12.7651 9.57676 12.7301 9.11756 12.5867C8.96108 12.5379 8.36681 12.1621 7.92624 11.9337C7.32191 11.6072 6.70764 11.2501 6.04386 11.2501H4.08363C3.78407 11.2501 3.59357 11.4892 3.59357 11.7188V17.1876H2.28675V11.2501H2.77681C3.43953 11.259 3.43953 10.3036 2.77681 10.3126H1.7967Z"
        fill="#2F74EE"
      />
      <path
        d="M18.4932 13.2288C17.3827 13.3252 15.5734 13.7141 14.255 14.0155C13.6108 14.1556 13.8419 15.081 14.4828 14.9274C15.7483 14.6381 17.4778 14.2708 18.46 14.1729C18.5581 14.3251 18.5812 14.3967 18.6094 14.5247C16.4896 15.3112 13.2536 16.7959 13.1077 16.8628L7.33868 17.1844C6.85645 17.0474 6.35864 16.8321 5.96104 16.662C5.3229 16.4262 4.98666 17.2926 5.58073 17.525C6.06778 17.7368 6.60904 17.9555 6.98263 18.0634C7.08816 18.0932 7.21607 18.1289 7.37825 18.1232L13.2589 17.793C13.3225 17.7894 13.3847 17.7741 13.4421 17.7478C13.4421 17.7478 17.0742 16.0842 19.1358 15.3351C20.1082 14.9617 19.3851 13.126 18.4932 13.2288Z"
        fill="#2F74EE"
      />
    </svg>
  );
};

export const WarningImage = ({ color = '#666666' }) => {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8668 12.2312L12.0936 2.2265C11.5734 1.32562 10.6123 0.770508 9.5718 0.770508C8.53136 0.770508 7.57022 1.32562 7.04999 2.2265L1.17532 12.4025C0.655101 13.3034 0.655101 14.4136 1.17532 15.3145C1.69554 16.2154 2.65669 16.7705 3.69713 16.7705H15.4465C15.4497 16.7705 15.4529 16.7705 15.4529 16.7705C17.0611 16.7705 18.3649 15.4668 18.3649 13.8585C18.3649 13.2558 18.1809 12.6944 17.8668 12.2312ZM10.8185 13.2051C10.8185 13.8934 10.2887 14.42 9.57501 14.42C8.86129 14.42 8.33155 13.8934 8.33155 13.2051V13.1765C8.33155 12.4913 8.86129 11.9616 9.57501 11.9616C10.2887 11.9616 10.8185 12.4882 10.8185 13.1765V13.2051ZM10.847 5.01476L10.2316 10.3883C10.1904 10.7753 9.93345 11.0163 9.57501 11.0163C9.21656 11.0163 8.95962 10.7721 8.91838 10.3883L8.303 5.01159C8.26176 4.59604 8.48701 4.28201 8.87397 4.28201H10.2729C10.6599 4.28518 10.8882 4.59922 10.847 5.01476Z"
        fill={color}
      />
    </svg>
  );
};
const Communication = ({ color = '#666666' }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3203 0.770508H5.69531C3.11078 0.770508 0.976562 2.90473 0.976562 5.48926C0.976562 7.8527 2.76562 9.81285 5.04209 10.1314C5.18525 10.1987 5.52213 10.1768 5.69531 10.1768V11.583C5.69531 11.756 5.79053 11.9149 5.94297 11.9964C6.09347 12.0771 6.27891 12.0698 6.42409 11.973L9.11847 10.1768H11.3203C13.9048 10.1768 16.0391 8.07379 16.0391 5.48926C16.0391 2.90473 13.9048 0.770508 11.3203 0.770508ZM5.69531 6.42676C5.1785 6.42676 4.75781 6.00607 4.75781 5.48926C4.75781 4.97245 5.1785 4.55176 5.69531 4.55176C6.21213 4.55176 6.63281 4.97245 6.63281 5.48926C6.63281 6.00607 6.21213 6.42676 5.69531 6.42676ZM8.50781 6.42676C7.991 6.42676 7.57031 6.00607 7.57031 5.48926C7.57031 4.97245 7.991 4.55176 8.50781 4.55176C9.02463 4.55176 9.44531 4.97245 9.44531 5.48926C9.44531 6.00607 9.02463 6.42676 8.50781 6.42676ZM11.3203 6.42676C10.8035 6.42676 10.3828 6.00607 10.3828 5.48926C10.3828 4.97245 10.8035 4.55176 11.3203 4.55176C11.8371 4.55176 12.2578 4.97245 12.2578 5.48926C12.2578 6.00607 11.8371 6.42676 11.3203 6.42676Z"
        fill={color}
      />
      <path
        d="M16.3966 7.96094C15.4795 9.82506 13.5345 11.1141 11.3203 11.1141H9.40228L6.94409 12.7528C6.50391 13.0469 5.94691 13.0621 5.49984 12.8224C5.04253 12.578 4.75781 12.1028 4.75781 11.5828V11.0358C3.70169 10.8578 2.72675 10.377 1.96178 9.70156C1.94575 9.85997 1.91406 10.0154 1.91406 10.1766C1.91406 12.7611 4.04828 14.8641 6.63281 14.8641H8.83466L11.5291 16.6916C11.6742 16.7883 11.8597 16.7957 12.0102 16.7149C12.1626 16.6334 12.2578 16.4746 12.2578 16.3016V14.8641C12.431 14.8641 12.7679 14.886 12.911 14.8187C15.1875 14.5002 16.9766 12.5395 16.9766 10.1766C16.9766 9.38537 16.762 8.63619 16.3966 7.96094Z"
        fill={color}
      />
    </svg>
  );
};
const DueDiligence = () => {
  return (
    <svg
      width="20"
      height="27"
      viewBox="0 0 20 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5383 3.13717H15.1432C14.8315 2.2243 13.9922 1.56858 13.0079 1.56858H12.1235C11.8118 0.655615 10.9721 0 9.98766 0C9.00321 0 8.16348 0.655615 7.85185 1.56858H6.96742C5.98307 1.56858 5.1438 2.2243 4.83211 3.13717H2.43706C1.18804 3.13717 0.171875 4.19267 0.171875 5.49004V24.4176C0.171875 25.715 1.18804 26.7705 2.43706 26.7705H17.5383C18.7873 26.7705 19.8034 25.715 19.8034 24.4176V5.49004C19.8034 4.19267 18.7873 3.13717 17.5383 3.13717ZM6.21236 3.92146C6.21236 3.489 6.55108 3.13717 6.96742 3.13717H8.47754C8.89453 3.13717 9.2326 2.78601 9.2326 2.35287C9.2326 1.92042 9.57132 1.56858 9.98766 1.56858C10.404 1.56858 10.7427 1.92042 10.7427 2.35287C10.7427 2.78601 11.0808 3.13717 11.4978 3.13717H13.0079C13.4242 3.13717 13.763 3.489 13.763 3.92146V4.70575H6.21236V3.92146ZM18.2933 24.4176C18.2933 24.8501 17.9546 25.2019 17.5383 25.2019H2.43706C2.02072 25.2019 1.682 24.8501 1.682 24.4176V5.49004C1.682 5.05758 2.02072 4.70575 2.43706 4.70575H4.70224V5.49004C4.70224 5.92318 5.0403 6.27433 5.4573 6.27433H14.518C14.935 6.27433 15.2731 5.92318 15.2731 5.49004V4.70575H17.5383C17.9546 4.70575 18.2933 5.05758 18.2933 5.49004V24.4176Z"
        fill="#666666"
      />
      <path
        d="M9.01073 13.6662C8.71591 13.36 8.2378 13.36 7.94293 13.6662L5.45661 16.2488L4.48037 15.2348C4.18554 14.9285 3.70744 14.9285 3.41256 15.2348C3.11769 15.5411 3.11769 16.0376 3.41256 16.3439L4.92273 17.9126C5.07012 18.0657 5.26337 18.1422 5.45661 18.1422C5.64986 18.1422 5.8431 18.0657 5.99049 17.9126L9.01073 14.7754C9.30561 14.4691 9.30561 13.9725 9.01073 13.6662Z"
        fill="#666666"
      />
      <path
        d="M9.01073 8.17698C8.71591 7.87069 8.2378 7.87069 7.94293 8.17698L5.45661 10.7596L4.48037 9.74552C4.18554 9.43922 3.70744 9.43922 3.41256 9.74552C3.11769 10.0518 3.11769 10.5484 3.41256 10.8547L4.92273 12.4233C5.07012 12.5764 5.26337 12.653 5.45661 12.653C5.64986 12.653 5.8431 12.5764 5.99049 12.4233L9.01073 9.28613C9.30561 8.97984 9.30561 8.48328 9.01073 8.17698Z"
        fill="#666666"
      />
      <path
        d="M9.01073 19.1535C8.71591 18.8473 8.2378 18.8473 7.94293 19.1535L5.45661 21.7362L4.48037 20.7222C4.18554 20.4159 3.70744 20.4159 3.41256 20.7222C3.11769 21.0285 3.11769 21.525 3.41256 21.8313L4.92273 23.3999C5.07012 23.5531 5.26337 23.6296 5.45661 23.6296C5.64986 23.6296 5.8431 23.5531 5.99049 23.3999L9.01073 20.2627C9.30561 19.9564 9.30561 19.4598 9.01073 19.1535Z"
        fill="#666666"
      />
      <path
        d="M16.0276 9.5166H11.4972C11.0803 9.5166 10.7422 9.86775 10.7422 10.3009C10.7422 10.734 11.0803 11.0852 11.4972 11.0852H16.0276C16.4446 11.0852 16.7827 10.734 16.7827 10.3009C16.7827 9.86775 16.4446 9.5166 16.0276 9.5166Z"
        fill="#666666"
      />
      <path
        d="M16.0276 20.4941H11.4972C11.0803 20.4941 10.7422 20.8453 10.7422 21.2784C10.7422 21.7116 11.0803 22.0627 11.4972 22.0627H16.0276C16.4446 22.0627 16.7827 21.7116 16.7827 21.2784C16.7827 20.8453 16.4446 20.4941 16.0276 20.4941Z"
        fill="#666666"
      />
      <path
        d="M16.0276 15.0068H11.4972C11.0803 15.0068 10.7422 15.358 10.7422 15.7911C10.7422 16.2243 11.0803 16.5754 11.4972 16.5754H16.0276C16.4446 16.5754 16.7827 16.2243 16.7827 15.7911C16.7827 15.358 16.4446 15.0068 16.0276 15.0068Z"
        fill="#666666"
      />
    </svg>
  );
};

const ExtendedSettlement = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_9124_102184)">
        <path
          d="M22.2713 2.14795C20.302 2.14795 18.7461 3.78939 18.7461 5.83487C18.7461 7.88036 20.3264 9.49655 22.2713 9.49655C24.2162 9.49655 25.8208 7.85511 25.8208 5.80962C25.8208 3.76414 24.2405 2.14795 22.2713 2.14795ZM22.2713 8.68845C20.7397 8.68845 19.4998 7.40055 19.4998 5.80962C19.4998 4.21869 20.764 2.95604 22.2713 2.95604C23.8029 2.95604 25.0428 4.24394 25.0428 5.83487C25.0428 7.42581 23.8029 8.68845 22.2713 8.68845Z"
          fill="#666666"
        />
        <path
          d="M23.3904 6.39077C23.3661 6.31499 23.3661 6.26448 23.3174 6.1887C23.2931 6.13819 23.2688 6.06241 23.2202 6.01189C23.1715 5.96138 23.1472 5.91086 23.0986 5.86034C23.0499 5.80983 23.0013 5.75931 22.9284 5.73405C22.8797 5.68354 22.8068 5.65828 22.7581 5.63302C22.6852 5.60776 22.6366 5.55724 22.5636 5.53199C22.4907 5.50673 22.4177 5.48147 22.3691 5.45621C22.3448 5.45621 22.2961 5.43095 22.2718 5.4057C22.2475 5.38044 22.1988 5.38044 22.1745 5.35518C22.1502 5.32992 22.1016 5.32992 22.0773 5.30466C22.0529 5.2794 22.0286 5.25414 22.0043 5.22889C21.98 5.20363 21.9557 5.17837 21.9557 5.12785C21.9314 5.1026 21.9314 5.05208 21.9314 5.02682C21.9314 4.9763 21.9314 4.95105 21.9314 4.90053C21.9314 4.87527 21.9557 4.82475 21.9557 4.7995C21.98 4.77424 21.98 4.72372 22.0043 4.69846C22.0286 4.6732 22.0529 4.64795 22.0773 4.62269C22.1016 4.59743 22.1502 4.57217 22.1989 4.57217C22.2475 4.54691 22.2718 4.54691 22.3204 4.54691C22.3448 4.54691 22.3691 4.54691 22.3934 4.54691C22.4177 4.54691 22.442 4.54691 22.4663 4.54691C22.515 4.54691 22.5393 4.54691 22.5879 4.57217C22.6366 4.57217 22.6852 4.59743 22.7095 4.59743C22.7338 4.59743 22.7825 4.62269 22.8068 4.62269C22.8554 4.62269 22.8797 4.64795 22.904 4.64795L23.0256 4.69846L23.0499 4.54691L23.0986 4.14278V4.04175L23.0013 4.01649C22.977 4.01649 22.9284 3.99123 22.904 3.99123C22.8797 3.99123 22.8554 3.96597 22.8068 3.96597C22.7825 3.96597 22.7338 3.94071 22.6852 3.94071C22.6366 3.94071 22.6122 3.91545 22.5636 3.91545H22.5393V3.56184V3.43555H22.4177H22.0773H21.9557V3.56184V3.94071H21.9314C21.8584 3.96597 21.7855 3.99123 21.7125 4.04175C21.6396 4.067 21.5909 4.11752 21.5423 4.16804C21.4937 4.21855 21.445 4.26907 21.3964 4.34485C21.3478 4.39536 21.3234 4.47114 21.2991 4.54691C21.2748 4.62269 21.2505 4.69846 21.2262 4.77424C21.2019 4.85001 21.2019 4.95105 21.2019 5.02682C21.2019 5.1026 21.2019 5.15311 21.2262 5.22889C21.2505 5.30466 21.2505 5.35518 21.2991 5.43095C21.3234 5.48147 21.3721 5.55724 21.3964 5.60776C21.445 5.65828 21.4693 5.70879 21.518 5.75931C21.5666 5.80983 21.6152 5.86034 21.6882 5.8856C21.7368 5.93612 21.8098 5.96138 21.8584 5.98664C21.9314 6.01189 22.0043 6.06241 22.0529 6.08767C22.1259 6.11293 22.1989 6.13819 22.2475 6.16344C22.2718 6.16344 22.3204 6.1887 22.3448 6.21396C22.3691 6.23922 22.4177 6.23922 22.442 6.26448C22.4663 6.28974 22.4907 6.31499 22.515 6.31499C22.5393 6.34025 22.5636 6.36551 22.5879 6.39077C22.6122 6.41603 22.6122 6.44129 22.6366 6.4918C22.6366 6.51706 22.6609 6.56758 22.6609 6.61809C22.6609 6.66861 22.6609 6.69387 22.6609 6.74439C22.6609 6.76964 22.6366 6.82016 22.6122 6.84542C22.5879 6.87068 22.5636 6.89594 22.5393 6.92119C22.515 6.94645 22.4907 6.97171 22.442 6.99697C22.4177 7.02223 22.3691 7.02223 22.3448 7.04748C22.3204 7.04748 22.2718 7.07274 22.2232 7.07274C22.1989 7.07274 22.1745 7.07274 22.1259 7.07274C22.1016 7.07274 22.0529 7.07274 22.0286 7.07274C21.98 7.07274 21.9314 7.07274 21.907 7.07274C21.8584 7.07274 21.8098 7.04748 21.7855 7.04748C21.7368 7.04748 21.6882 7.02223 21.6396 6.99697C21.5909 6.97171 21.5423 6.97171 21.4937 6.94645C21.4693 6.94645 21.445 6.92119 21.4207 6.92119C21.3964 6.92119 21.3721 6.89593 21.3478 6.89593L21.2019 6.82016L21.1775 6.99697L21.1289 7.45162V7.52739L21.2019 7.55265C21.2991 7.52739 21.3478 7.55265 21.4207 7.57791C21.4693 7.60317 21.5423 7.62843 21.5909 7.62843C21.6396 7.65368 21.7125 7.65368 21.7855 7.67894C21.8584 7.7042 21.907 7.7042 21.98 7.7042H22.0286V8.08308V8.20937H22.1502H22.4907H22.6122V8.08308V7.67894H22.6366C22.7095 7.65368 22.7825 7.62843 22.8554 7.57791C22.9284 7.55265 22.977 7.50213 23.0499 7.45162C23.0986 7.4011 23.1472 7.35058 23.1958 7.27481C23.2445 7.22429 23.2688 7.14852 23.3174 7.07274C23.3417 6.99697 23.3661 6.92119 23.3904 6.84542C23.4147 6.76964 23.4147 6.69387 23.4147 6.59284C23.4147 6.51706 23.4147 6.46654 23.3904 6.39077Z"
          fill="#666666"
        />
        <path
          d="M20.5697 9.97596C20.4482 9.79919 20.1807 9.77394 20.0105 9.9002L16.072 13.1578L10.9909 10.9608C10.8693 10.9103 10.7235 10.9356 10.6262 11.0113L5.1804 15.0518C5.01021 15.1781 4.96159 15.4306 5.08315 15.6074C5.15609 15.7336 5.27764 15.7841 5.3992 15.7841C5.47214 15.7841 5.54507 15.7589 5.61801 15.7084L10.8936 11.7942L15.9991 13.9912C16.1207 14.0417 16.2909 14.0164 16.3881 13.9407L20.4968 10.5568C20.667 10.4305 20.6913 10.1527 20.5697 9.97596Z"
          fill="#666666"
        />
        <path
          d="M26.2573 23.8149H24.4582V12.1228C24.4582 11.8955 24.2881 11.7188 24.0692 11.7188H20.4954C20.2766 11.7188 20.1064 11.8955 20.1064 12.1228V23.8149H18.7936V16.1633C18.7936 15.936 18.6234 15.7592 18.4046 15.7592H14.8065C14.5877 15.7592 14.4175 15.936 14.4175 16.1633V23.8149H13.1047V15.5572C13.1047 15.3299 12.9345 15.1531 12.7157 15.1531H9.14186C8.92305 15.1531 8.75287 15.3299 8.75287 15.5572V23.8149H7.44004V17.931C7.44004 17.7037 7.26985 17.5269 7.05105 17.5269H3.45292C3.23411 17.5269 3.06393 17.7037 3.06393 17.931V23.8149H1.24055C1.02174 23.8149 0.851562 23.9917 0.851562 24.2189C0.851562 24.4462 1.02174 24.623 1.24055 24.623H3.4286H7.00243H9.14186H12.7157H14.8065H18.3803H20.4711H24.0449H26.233C26.4518 24.623 26.622 24.4462 26.622 24.2189C26.6463 23.9917 26.4761 23.8149 26.2573 23.8149ZM6.63775 23.8149H3.8419V18.335H6.63775V23.8149ZM12.3267 23.8149H9.53084V15.9612H12.3267V23.8149ZM17.9913 23.8149H15.1955V16.5673H17.9913V23.8149ZM23.6803 23.8149H20.8844V12.5268H23.6803V23.8149Z"
          fill="#666666"
        />
      </g>
      <defs>
        <clipPath id="clip0_9124_102184">
          <rect
            width="25.7727"
            height="26.7705"
            fill="white"
            transform="translate(0.851562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const line = () => {
  return (
    <svg
      width="2"
      height="97"
      viewBox="0 0 2 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0.773438"
        y1="2.18557e-08"
        x2="0.773433"
        y2="97"
        stroke="#DFDFDF"
      />
    </svg>
  );
};
const shower = () => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_23468_90054)">
        <path
          d="M12.625 0.5C12.2108 0.5 11.875 0.835781 11.875 1.25V1.5H6.375C5.685 1.50081 5.12581 2.06 5.125 2.75V4H4.625C4.21078 4 3.875 4.33578 3.875 4.75V5.61125C2.78603 6.28247 2.1235 7.47078 2.125 8.75V9.046C1.82641 9.15156 1.62631 9.43331 1.625 9.75V10.25C1.625 10.3881 1.73694 10.5 1.875 10.5H9.875C10.0131 10.5 10.125 10.3881 10.125 10.25V9.75C10.1237 9.43331 9.92359 9.15156 9.625 9.046V8.75C9.62647 7.7545 9.23053 6.79959 8.525 6.09725C8.32894 5.90819 8.11066 5.74356 7.875 5.607V4.75C7.875 4.33578 7.53922 4 7.125 4H6.625V3.25C6.625 3.11194 6.73694 3 6.875 3H11.875V3.5C11.875 3.91422 12.2108 4.25 12.625 4.25H13.375V0.5H12.625ZM9.625 9.75V10H2.125V9.75C2.125 9.61194 2.23694 9.5 2.375 9.5H9.375C9.51306 9.5 9.625 9.61194 9.625 9.75ZM8.17275 6.4515C8.78369 7.06022 9.12644 7.88756 9.125 8.75V9H2.625V8.75C2.62419 7.62038 3.22063 6.5745 4.19325 6H7.5585C7.78212 6.12297 7.98866 6.27475 8.17275 6.4515ZM7.125 4.5C7.26306 4.5 7.375 4.61194 7.375 4.75V5.5H4.375V4.75C4.375 4.61194 4.48694 4.5 4.625 4.5H7.125ZM11.875 2.5H6.875C6.46078 2.5 6.125 2.83578 6.125 3.25V4H5.625V2.75C5.625 2.33578 5.96078 2 6.375 2H11.875V2.5ZM12.875 3.75H12.625C12.4869 3.75 12.375 3.63806 12.375 3.5V1.25C12.375 1.11194 12.4869 1 12.625 1H12.875V3.75Z"
          fill="#6C2AD2"
        />
        <path
          d="M5.875 11C5.73694 11 5.625 11.1119 5.625 11.25V12.25C5.625 12.3881 5.73694 12.5 5.875 12.5C6.01306 12.5 6.125 12.3881 6.125 12.25V11.25C6.125 11.1119 6.01306 11 5.875 11Z"
          fill="#6C2AD2"
        />
        <path
          d="M5.875 13C5.73694 13 5.625 13.1119 5.625 13.25V14.25C5.625 14.3881 5.73694 14.5 5.875 14.5C6.01306 14.5 6.125 14.3881 6.125 14.25V13.25C6.125 13.1119 6.01306 13 5.875 13Z"
          fill="#6C2AD2"
        />
        <path
          d="M8.875 12C8.73694 12 8.625 12.1119 8.625 12.25V13.25C8.625 13.3881 8.73694 13.5 8.875 13.5C9.01306 13.5 9.125 13.3881 9.125 13.25V12.25C9.125 12.1119 9.01306 12 8.875 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M6.875 12C6.73694 12 6.625 12.1119 6.625 12.25V13.25C6.625 13.3881 6.73694 13.5 6.875 13.5C7.01306 13.5 7.125 13.3881 7.125 13.25V12.25C7.125 12.1119 7.01306 12 6.875 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M4.875 12C4.73694 12 4.625 12.1119 4.625 12.25V13.25C4.625 13.3881 4.73694 13.5 4.875 13.5C5.01306 13.5 5.125 13.3881 5.125 13.25V12.25C5.125 12.1119 5.01306 12 4.875 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M2.875 12C2.73694 12 2.625 12.1119 2.625 12.25V13.25C2.625 13.3881 2.73694 13.5 2.875 13.5C3.01306 13.5 3.125 13.3881 3.125 13.25V12.25C3.125 12.1119 3.01306 12 2.875 12Z"
          fill="#6C2AD2"
        />
        <path
          d="M3.875 11C3.73694 11 3.625 11.1119 3.625 11.25V12.25C3.625 12.3881 3.73694 12.5 3.875 12.5C4.01306 12.5 4.125 12.3881 4.125 12.25V11.25C4.125 11.1119 4.01306 11 3.875 11Z"
          fill="#6C2AD2"
        />
        <path
          d="M7.875 11C7.73694 11 7.625 11.1119 7.625 11.25V12.25C7.625 12.3881 7.73694 12.5 7.875 12.5C8.01306 12.5 8.125 12.3881 8.125 12.25V11.25C8.125 11.1119 8.01306 11 7.875 11Z"
          fill="#6C2AD2"
        />
        <path
          d="M7.875 13C7.73694 13 7.625 13.1119 7.625 13.25V14.25C7.625 14.3881 7.73694 14.5 7.875 14.5C8.01306 14.5 8.125 14.3881 8.125 14.25V13.25C8.125 13.1119 8.01306 13 7.875 13Z"
          fill="#6C2AD2"
        />
        <path
          d="M3.875 13C3.73694 13 3.625 13.1119 3.625 13.25V14.25C3.625 14.3881 3.73694 14.5 3.875 14.5C4.01306 14.5 4.125 14.3881 4.125 14.25V13.25C4.125 13.1119 4.01306 13 3.875 13Z"
          fill="#6C2AD2"
        />
        <path
          d="M4.875 14C4.73694 14 4.625 14.1119 4.625 14.25V15.25C4.625 15.3881 4.73694 15.5 4.875 15.5C5.01306 15.5 5.125 15.3881 5.125 15.25V14.25C5.125 14.1119 5.01306 14 4.875 14Z"
          fill="#6C2AD2"
        />
        <path
          d="M6.875 14C6.73694 14 6.625 14.1119 6.625 14.25V15.25C6.625 15.3881 6.73694 15.5 6.875 15.5C7.01306 15.5 7.125 15.3881 7.125 15.25V14.25C7.125 14.1119 7.01306 14 6.875 14Z"
          fill="#6C2AD2"
        />
      </g>
      <defs>
        <clipPath id="clip0_23468_90054">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const bed = () => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.24513 8.8926H13.7555C14.2711 8.8926 14.6891 8.47462 14.6891 7.95899C14.6891 7.44337 14.2711 7.02539 13.7555 7.02539H1.24513C0.729502 7.02539 0.311523 7.44337 0.311523 7.95899C0.311494 8.47462 0.729502 8.8926 1.24513 8.8926Z"
        fill="#6C2AD2"
      />
      <path
        d="M8.4336 5.01172C8.16111 5.01172 7.93945 5.23338 7.93945 5.50587V6.1465H11.7638V5.50587C11.7638 5.23338 11.5422 5.01172 11.2697 5.01172H8.4336Z"
        fill="#6C2AD2"
      />
      <path
        d="M2.35707 5.50547C2.35707 4.74835 2.97301 4.13241 3.73013 4.13241H6.56621C6.9265 4.13241 7.25463 4.2721 7.49981 4.49991C7.745 4.2721 8.07312 4.13241 8.43342 4.13241H11.2695C12.0266 4.13241 12.6426 4.74835 12.6426 5.50547V6.1461H14.069V3.11915C14.069 2.60353 13.651 2.18555 13.1354 2.18555H1.86427C1.34864 2.18555 0.930664 2.60353 0.930664 3.11915V6.1461H2.35707V5.50547Z"
        fill="#6C2AD2"
      />
      <path
        d="M3.73048 5.01172C3.45799 5.01172 3.23633 5.23338 3.23633 5.50587V6.1465H7.06071V5.50587C7.06071 5.23338 6.83905 5.01172 6.56656 5.01172H3.73048Z"
        fill="#6C2AD2"
      />
      <path
        d="M0 9.77148V13.815H0.878906V12.2125H14.1211V13.815H15V9.77148H0Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

const parkedcar = () => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_23468_90057)">
        <path
          d="M10.6373 6.9984C10.589 6.9984 10.5395 7.00533 10.4899 7.01893L9.93004 7.17315L9.34875 5.75694C9.18401 5.35575 8.69717 5.0293 8.2635 5.0293H2.82268C2.38895 5.0293 1.90217 5.35575 1.73749 5.75694L1.15691 7.17117L0.603967 7.01887C0.554485 7.00528 0.504948 6.99834 0.456677 6.99834C0.192039 6.99834 0 7.20051 0 7.47896V7.80899C0 8.13406 0.264528 8.39859 0.589602 8.39859H0.652954L0.559109 8.62718C0.406094 8.99981 0.281536 9.63091 0.281536 10.0339V12.8474C0.281536 13.1724 0.546064 13.437 0.871137 13.437H1.64116C1.96624 13.437 2.23077 13.1724 2.23077 12.8474V12.1448H8.85536V12.8474C8.85536 13.1724 9.11989 13.437 9.44496 13.437H10.2149C10.54 13.437 10.8045 13.1724 10.8045 12.8474V10.034C10.8045 9.63102 10.6799 8.99992 10.5269 8.62723L10.4331 8.39865H10.5043C10.8294 8.39865 11.0939 8.13412 11.0939 7.80904V7.47902C11.0939 7.20056 10.9018 6.9984 10.6373 6.9984ZM1.57957 8.07842L2.45902 5.93632C2.55755 5.69634 2.85036 5.49995 3.10977 5.49995H7.97641C8.23582 5.49995 8.52864 5.69629 8.62716 5.93632L9.50661 8.07842C9.60508 8.3184 9.47348 8.51478 9.21407 8.51478H1.87217C1.61271 8.51473 1.4811 8.3184 1.57957 8.07842ZM3.54273 10.7879C3.54273 10.9177 3.43655 11.0237 3.30693 11.0237H1.63632C1.50659 11.0237 1.40047 10.9176 1.40047 10.7879V9.9862C1.40047 9.85652 1.50659 9.7504 1.63632 9.7504H3.30693C3.43655 9.7504 3.54273 9.85652 3.54273 9.9862V10.7879ZM9.66986 10.7879C9.66986 10.9177 9.56369 11.0237 9.43407 11.0237H7.76345C7.63383 11.0237 7.52766 10.9176 7.52766 10.7879V9.9862C7.52766 9.85652 7.63383 9.7504 7.76345 9.7504H9.43407C9.56369 9.7504 9.66986 9.85652 9.66986 9.9862V10.7879Z"
          fill="#6C2AD2"
        />
        <path
          d="M14.2624 2.5625H11.4699C11.0632 2.5625 10.7324 2.89335 10.7324 3.29994V6.09251C10.7324 6.49916 11.0633 6.83001 11.4699 6.83001H12.5909V13.0977C12.5909 13.2497 12.7141 13.3729 12.8661 13.3729C13.0181 13.3729 13.1413 13.2497 13.1413 13.0977V6.83007H14.2624C14.669 6.83007 14.9998 6.49921 14.9998 6.09257V3.3C14.9998 2.89335 14.669 2.5625 14.2624 2.5625ZM13.6299 4.87792C13.4693 5.02251 13.2327 5.09583 12.9268 5.09583H12.5224C12.4739 5.09583 12.4344 5.1354 12.4344 5.18395V5.86585C12.4344 5.93994 12.3741 6.00015 12.3 6.00015H11.9937C11.9196 6.00015 11.8594 5.93988 11.8594 5.86585V3.52688C11.8594 3.45274 11.9197 3.39247 11.9937 3.39247H12.7652C13.2763 3.39247 13.467 3.46947 13.6238 3.6025C13.7891 3.7428 13.8729 3.95768 13.8729 4.24131C13.8729 4.51844 13.7912 4.73256 13.6299 4.87792Z"
          fill="#6C2AD2"
        />
        <path
          d="M13.1924 3.95803C13.1177 3.90167 12.9857 3.87305 12.8 3.87305H12.5226C12.4741 3.87305 12.4346 3.91257 12.4346 3.96106V4.52149C12.4346 4.56998 12.4741 4.6095 12.5226 4.6095H12.6888C12.7498 4.6095 12.8485 4.60498 12.9086 4.59943C12.967 4.59409 13.1319 4.5702 13.1924 4.52451C13.265 4.46958 13.3018 4.37458 13.3018 4.24221C13.3018 4.10857 13.265 4.01296 13.1924 3.95803Z"
          fill="#6C2AD2"
        />
      </g>
      <defs>
        <clipPath id="clip0_23468_90057">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const Finance = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_9124_102187)">
        <path
          d="M22.599 0H4.4272C3.41291 0.00110727 2.44046 0.420124 1.72324 1.16511C1.00603 1.91009 0.602628 2.92018 0.601563 3.97374L0.601562 7.16319C0.601563 7.3712 0.681113 7.57069 0.822715 7.71777C0.964316 7.86486 1.15637 7.94749 1.35662 7.94749H6.74272V25.9862C6.74272 26.1942 6.82227 26.3937 6.96387 26.5408C7.10547 26.6878 7.29753 26.7705 7.49778 26.7705H25.6192C25.8195 26.7705 26.0115 26.6878 26.1531 26.5408C26.2947 26.3937 26.3743 26.1942 26.3743 25.9862V3.92146C26.3731 2.8818 25.975 1.88509 25.2672 1.14994C24.5595 0.414798 23.5999 0.00124534 22.599 0V0ZM2.11168 6.3789V3.97374C2.11248 3.33611 2.35669 2.72483 2.79077 2.27395C3.22484 1.82308 3.81333 1.56941 4.4272 1.56858H6.74272V6.3789H2.11168ZM24.8642 25.2019H8.25284V1.56858H22.599C23.1995 1.56927 23.7753 1.81739 24.2 2.25849C24.6246 2.69959 24.8635 3.29765 24.8642 3.92146V25.2019Z"
          fill="#666666"
        />
        <path
          d="M17.8171 13.6315H14.4641C14.2639 13.6315 14.0718 13.7141 13.9302 13.8612C13.7886 14.0083 13.709 14.2078 13.709 14.4158C13.709 14.6238 13.7886 14.8233 13.9302 14.9704C14.0718 15.1175 14.2639 15.2001 14.4641 15.2001H15.8036V16.1564C15.8036 16.3644 15.8831 16.5639 16.0247 16.711C16.1663 16.8581 16.3584 16.9407 16.5586 16.9407C16.7589 16.9407 16.9509 16.8581 17.0926 16.711C17.2342 16.5639 17.3137 16.3644 17.3137 16.1564V15.2001H17.8171C18.2394 15.1997 18.6443 15.0253 18.943 14.7151C19.2417 14.405 19.4097 13.9844 19.4103 13.5458V10.9351C19.4097 10.4964 19.2417 10.0759 18.943 9.76575C18.6443 9.45561 18.2394 9.2812 17.8171 9.28078H15.3002C15.2783 9.28078 15.2572 9.27177 15.2417 9.2557C15.2261 9.23963 15.2173 9.21782 15.2172 9.19503V6.58439C15.2172 6.57308 15.2193 6.56189 15.2235 6.55145C15.2277 6.54101 15.2338 6.53154 15.2415 6.52357C15.2492 6.5156 15.2584 6.50929 15.2685 6.50502C15.2785 6.50074 15.2893 6.49857 15.3002 6.49864H18.6512C18.8514 6.49864 19.0435 6.41601 19.1851 6.26893C19.3267 6.12184 19.4062 5.92236 19.4062 5.71435C19.4062 5.50634 19.3267 5.30685 19.1851 5.15977C19.0435 5.01269 18.8514 4.93006 18.6512 4.93006H17.3137V3.97374C17.3137 3.76574 17.2342 3.56625 17.0926 3.41917C16.9509 3.27208 16.7589 3.18945 16.5586 3.18945C16.3584 3.18945 16.1663 3.27208 16.0247 3.41917C15.8831 3.56625 15.8036 3.76574 15.8036 3.97374V4.93006H15.3002C14.8779 4.93047 14.473 5.10488 14.1743 5.41503C13.8756 5.72517 13.7076 6.14571 13.707 6.58439V9.19503C13.7076 9.63371 13.8756 10.0543 14.1743 10.3644C14.473 10.6745 14.8779 10.849 15.3002 10.8494H17.8171C17.839 10.8494 17.8601 10.8584 17.8756 10.8744C17.8912 10.8905 17.9 10.9123 17.9001 10.9351V13.5458C17.9001 13.5571 17.898 13.5683 17.8938 13.5787C17.8896 13.5891 17.8835 13.5986 17.8758 13.6066C17.8681 13.6145 17.8589 13.6209 17.8488 13.6251C17.8387 13.6294 17.828 13.6316 17.8171 13.6315V13.6315Z"
          fill="#666666"
        />
        <path
          d="M22.0949 20.1826H11.0207C10.8204 20.1826 10.6284 20.2652 10.4868 20.4123C10.3452 20.5594 10.2656 20.7589 10.2656 20.9669C10.2656 21.1749 10.3452 21.3744 10.4868 21.5215C10.6284 21.6686 10.8204 21.7512 11.0207 21.7512H22.0949C22.2952 21.7512 22.4872 21.6686 22.6288 21.5215C22.7704 21.3744 22.85 21.1749 22.85 20.9669C22.85 20.7589 22.7704 20.5594 22.6288 20.4123C22.4872 20.2652 22.2952 20.1826 22.0949 20.1826Z"
          fill="#666666"
        />
      </g>
      <defs>
        <clipPath id="clip0_9124_102187">
          <rect
            width="25.7727"
            height="26.7705"
            fill="white"
            transform="translate(0.601562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const EyeIcon = ({ color = '#000000' }) => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.363281"
        width="30"
        height="30"
        rx="5"
        fill={color}
      />
      <path
        d="M24.2966 15.0371C24.1549 14.8308 20.7483 10 15.3632 10C10.7424 10 6.62484 14.8031 6.45159 15.0078C6.33385 15.1473 6.33385 15.3521 6.45159 15.4923C6.62484 15.6971 10.7424 20.5002 15.3632 20.5002C19.9841 20.5002 24.1016 15.6971 24.2749 15.4923C24.3836 15.3634 24.3934 15.1766 24.2966 15.0371ZM15.3632 19.7502C11.6589 19.7502 8.13686 16.2176 7.24212 15.2501C8.13539 14.2819 11.6537 10.75 15.3632 10.75C19.6976 10.75 22.7569 14.2774 23.5039 15.2299C22.6413 16.1666 19.099 19.7502 15.3632 19.7502Z"
        fill={color}
      />
      <path
        d="M15.3633 12.251C13.7088 12.251 12.3633 13.5965 12.3633 15.251C12.3633 16.9055 13.7088 18.2511 15.3633 18.2511C17.0178 18.2511 18.3634 16.9055 18.3634 15.251C18.3634 13.5965 17.0178 12.251 15.3633 12.251ZM15.3633 17.5011C14.1228 17.5011 13.1133 16.4916 13.1133 15.2511C13.1133 14.0105 14.1228 13.001 15.3633 13.001C16.6038 13.001 17.6134 14.0105 17.6134 15.2511C17.6134 16.4916 16.6038 17.5011 15.3633 17.5011Z"
        fill={color}
      />
    </svg>
  );
};

export const FileCopy = ({ color = '#000000' }) => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke={color}
      />
      <path
        d="M19.9234 9.73628C19.8833 9.68948 19.8343 9.65103 19.7794 9.62313C19.7244 9.59524 19.6645 9.57844 19.6031 9.5737C19.5416 9.56896 19.4798 9.57637 19.4213 9.5955C19.3627 9.61464 19.3084 9.64512 19.2616 9.68522C19.2148 9.72532 19.1764 9.77424 19.1485 9.8292C19.1206 9.88416 19.1038 9.94407 19.099 10.0055C19.0943 10.067 19.1017 10.1287 19.1209 10.1873C19.14 10.2459 19.1705 10.3002 19.2106 10.347L19.9344 11.1916C19.9783 11.2429 20.0327 11.284 20.094 11.3123C20.1553 11.3406 20.222 11.3553 20.2895 11.3555H20.2907C20.358 11.3555 20.4245 11.3411 20.4857 11.3131C20.5469 11.2851 20.6013 11.2443 20.6453 11.1934L22.3671 9.20591C22.4074 9.15934 22.4382 9.10528 22.4576 9.04683C22.477 8.98837 22.4848 8.92666 22.4804 8.86521C22.476 8.80376 22.4595 8.74379 22.4319 8.68871C22.4043 8.63363 22.3661 8.58452 22.3196 8.54419C22.273 8.50386 22.2189 8.47309 22.1605 8.45365C22.102 8.43422 22.0403 8.42648 21.9789 8.43089C21.9174 8.4353 21.8574 8.45177 21.8024 8.47936C21.7473 8.50695 21.6982 8.54512 21.6578 8.59169L20.2925 10.1673L19.9234 9.73628Z"
        fill={color}
      />
      <path
        d="M22.9016 9.92152C22.7774 9.92031 22.6577 9.96809 22.5684 10.0545C22.4792 10.1409 22.4275 10.259 22.4247 10.3832C22.4178 10.7922 22.2902 11.19 22.0579 11.5268C21.8257 11.8635 21.4991 12.1241 21.1192 12.2758C20.7393 12.4276 20.3231 12.4637 19.9227 12.3796C19.5224 12.2956 19.1558 12.0952 18.869 11.8035C18.5822 11.5118 18.388 11.1419 18.3108 10.7401C18.2335 10.3384 18.2767 9.92287 18.4348 9.54561C18.5929 9.16835 18.859 8.84622 19.1996 8.61969C19.5403 8.39315 19.9402 8.2723 20.3493 8.27231C20.4737 8.27231 20.5931 8.22287 20.6811 8.13486C20.7691 8.04686 20.8185 7.9275 20.8185 7.80305C20.8185 7.67859 20.7691 7.55924 20.6811 7.47123C20.5931 7.38323 20.4737 7.33379 20.3493 7.33379C19.7535 7.33326 19.171 7.51036 18.6764 7.84247C18.6026 7.59938 18.4527 7.38637 18.2489 7.23474C18.0451 7.0831 17.798 7.00082 17.544 7H11.2999C11.2276 7.00044 11.1564 7.01776 11.0919 7.05057C11.0839 7.05454 11.0764 7.0588 11.0686 7.06326C11.0317 7.08357 10.9976 7.10877 10.9674 7.13818L7.50076 10.6047C7.41708 10.6902 7.36961 10.8047 7.36822 10.9243L7.36328 10.9228V19.3355C7.36362 19.651 7.4891 19.9534 7.71218 20.1765C7.93525 20.3996 8.23771 20.525 8.55319 20.5254H10.2116V21.6999C10.2119 22.0153 10.3373 22.3178 10.5604 22.5409C10.7835 22.764 11.086 22.8894 11.4015 22.8898H20.3923C20.7078 22.8895 21.0103 22.764 21.2334 22.5409C21.4565 22.3179 21.582 22.0154 21.5823 21.6999V13.0927C22.1033 12.8576 22.547 12.4798 22.8622 12.003C23.1774 11.5262 23.3511 10.9698 23.3632 10.3984C23.3652 10.274 23.3177 10.1538 23.2311 10.0644C23.1445 9.975 23.026 9.9236 22.9016 9.92152ZM10.8306 8.60199V10.2227C10.8305 10.2875 10.8047 10.3497 10.7589 10.3955C10.713 10.4414 10.6509 10.4672 10.586 10.4673H8.96538L10.8306 8.60199ZM10.3491 12.969C10.3048 13.0139 10.2701 13.0674 10.2472 13.1261C10.2242 13.1848 10.2134 13.2476 10.2154 13.3106L10.2116 13.3088V19.5869H8.55319C8.48655 19.5867 8.42267 19.5602 8.37555 19.5131C8.32842 19.466 8.3019 19.4021 8.3018 19.3355V11.4057H10.586C10.8997 11.4053 11.2004 11.2805 11.4222 11.0587C11.644 10.8369 11.7688 10.5362 11.7691 10.2226V7.93852H17.544C17.6106 7.93862 17.6745 7.96514 17.7216 8.01226C17.7688 8.05939 17.7953 8.12327 17.7954 8.18991V8.75422C17.6753 8.9459 17.5772 9.15056 17.5031 9.36428H14.1451L14.1459 9.369C14.0228 9.36783 13.9041 9.41558 13.8161 9.50176L10.3491 12.969ZM13.6786 10.9665V12.5872C13.6785 12.6519 13.6527 12.714 13.607 12.7598C13.5612 12.8056 13.4991 12.8314 13.4343 12.8315H11.8137L13.6786 10.9665ZM20.6438 21.6999C20.6437 21.7665 20.6172 21.8304 20.57 21.8775C20.5229 21.9246 20.459 21.9511 20.3924 21.9512H11.4015C11.3348 21.9511 11.271 21.9246 11.2238 21.8775C11.1767 21.8304 11.1502 21.7665 11.1501 21.6999V13.7699H13.4343C13.7479 13.7695 14.0486 13.6448 14.2704 13.4231C14.4921 13.2013 14.6168 12.9006 14.6172 12.587V10.3028H17.3371C17.3368 10.3181 17.3348 10.3328 17.3348 10.3481C17.3357 11.1473 17.6536 11.9134 18.2187 12.4785C18.7838 13.0436 19.5499 13.3615 20.3491 13.3624C20.4485 13.3624 20.5467 13.3571 20.6437 13.3475L20.6438 21.6999Z"
        fill={color}
      />
      <path
        d="M18.8971 14.6562H12.7739C12.6495 14.6563 12.5301 14.7057 12.4421 14.7937C12.3541 14.8817 12.3047 15.0011 12.3047 15.1255C12.3047 15.25 12.3541 15.3693 12.4421 15.4573C12.5301 15.5453 12.6495 15.5948 12.7739 15.5948H18.8971C19.0215 15.5948 19.1409 15.5453 19.2289 15.4573C19.3169 15.3693 19.3663 15.25 19.3663 15.1255C19.3663 15.0011 19.3169 14.8817 19.2289 14.7937C19.1409 14.7057 19.0215 14.6562 18.8971 14.6562Z"
        fill={color}
      />
      <path
        d="M16.9041 16.3159H12.7739C12.6495 16.3159 12.5301 16.3654 12.4421 16.4534C12.3541 16.5414 12.3047 16.6607 12.3047 16.7852C12.3047 16.9096 12.3541 17.029 12.4421 17.117C12.5301 17.205 12.6495 17.2544 12.7739 17.2544H16.9041C17.0285 17.2544 17.1479 17.205 17.2359 17.117C17.3239 17.029 17.3733 16.9096 17.3733 16.7852C17.3733 16.6607 17.3239 16.5414 17.2359 16.4534C17.1479 16.3654 17.0285 16.3159 16.9041 16.3159Z"
        fill={color}
      />
      <path
        d="M16.9028 19.4595H15.8475C15.7614 19.4593 15.6788 19.4251 15.6178 19.3642C15.5569 19.3032 15.5227 19.2206 15.5225 19.1345V19.0648C15.5225 18.9328 15.4866 18.8032 15.4187 18.6901C15.3507 18.5769 15.2532 18.4843 15.1367 18.4223C15.0202 18.3602 14.889 18.3311 14.7571 18.3379C14.6253 18.3447 14.4978 18.3872 14.3883 18.4609L12.7856 19.5393C12.6823 19.6088 12.6108 19.7164 12.5869 19.8386C12.563 19.9607 12.5885 20.0874 12.658 20.1906C12.7274 20.2939 12.8351 20.3654 12.9572 20.3893C13.0793 20.4132 13.206 20.3877 13.3093 20.3182L14.6205 19.4362C14.6883 19.7105 14.846 19.9542 15.0684 20.1285C15.2908 20.3028 15.5651 20.3977 15.8476 20.3981H16.9029C17.0274 20.3981 17.1467 20.3486 17.2347 20.2606C17.3227 20.1726 17.3722 20.0533 17.3722 19.9288C17.3722 19.8044 17.3227 19.685 17.2347 19.597C17.1467 19.509 17.0274 19.4595 16.9029 19.4595L16.9028 19.4595Z"
        fill={color}
      />
      <path
        d="M18.8957 19.4585H18.3521C18.2276 19.4585 18.1083 19.5079 18.0203 19.5959C17.9323 19.6839 17.8828 19.8033 17.8828 19.9278C17.8828 20.0522 17.9323 20.1716 18.0203 20.2596C18.1083 20.3476 18.2276 20.397 18.3521 20.397H18.8957C19.0201 20.397 19.1395 20.3476 19.2275 20.2596C19.3155 20.1716 19.3649 20.0522 19.3649 19.9278C19.3649 19.8033 19.3155 19.6839 19.2275 19.5959C19.1395 19.5079 19.0201 19.4585 18.8957 19.4585Z"
        fill={color}
      />
    </svg>
  );
};

export const SignContract = ({ color = '#666666' }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="5" fill="black" fill-opacity="0.1" />
      <path
        d="M11.1291 12.6786C11.1291 12.3984 11.3159 12.2115 11.5961 12.2115H17.5742C17.8544 12.2115 18.0412 12.3984 18.0412 12.6786C18.0412 12.9588 17.8544 13.1456 17.5742 13.1456H11.5961C11.3626 13.1456 11.1291 12.9588 11.1291 12.6786ZM11.5961 15.9478H17.5742C17.8544 15.9478 18.0412 15.761 18.0412 15.4808C18.0412 15.2005 17.8544 15.0137 17.5742 15.0137H11.5961C11.3159 15.0137 11.1291 15.2005 11.1291 15.4808C11.1291 15.761 11.3626 15.9478 11.5961 15.9478ZM11.5961 18.7033H15.1456C15.4258 18.7033 15.6126 18.5165 15.6126 18.2363C15.6126 17.956 15.4258 17.7692 15.1456 17.7692H11.5961C11.3159 17.7692 11.1291 17.956 11.1291 18.2363C11.1291 18.4698 11.3626 18.7033 11.5961 18.7033ZM25 15.6676C25 15.9011 24.9066 16.1346 24.7198 16.3214L18.4615 22.4863C18.3681 22.5797 18.2747 22.6264 18.1813 22.6731L15.6593 23.7006C15.5659 23.7473 15.1456 23.8874 14.772 23.5137C14.5385 23.2802 14.445 22.9533 14.5852 22.6264L15.5659 20.1044C15.6126 20.011 15.6593 19.9176 15.7527 19.8242L20.2363 15.3874V9.73626H17.761C17.4808 9.73626 17.294 9.54945 17.294 9.26923V6.93406H9.54121C9.21429 6.93406 8.93407 7.21428 8.93407 7.5412V20.805C8.93407 21.1319 9.21429 21.4121 9.54121 21.4121H12.9973C13.2775 21.4121 13.4643 21.5989 13.4643 21.8791C13.4643 22.1593 13.2775 22.3462 12.9973 22.3462H9.54121C8.70055 22.3462 8 21.6456 8 20.805V7.5412C8 6.70055 8.70055 6 9.54121 6H17.761C17.9478 6 18.0412 6.09341 18.0879 6.14011L21.0302 8.9423C21.1703 9.08241 21.1703 9.26923 21.1703 9.26923V14.4533L22.011 13.6126C22.3846 13.239 22.9451 13.239 23.3187 13.6126L24.7198 15.0137C24.9066 15.2005 25 15.3874 25 15.6676ZM18.228 8.80219H19.5357L19.3022 8.56868L18.228 7.5412V8.80219ZM17.294 22.0192L16.2665 20.9451L15.5659 22.7198L17.294 22.0192ZM24.0659 15.6209L22.6648 14.2665L16.7802 20.1511L18.1346 21.5522L24.0659 15.6209Z"
        fill="#666666"
      />
    </svg>
  );
};

export const DepositIcon = ({ color = '#666666' }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="5" fill="black" fill-opacity="0.1" />
      <path
        d="M14.8464 23.6927C17.1926 23.6927 19.4427 22.7607 21.1017 21.1017C22.7607 19.4427 23.6927 17.1926 23.6927 14.8464C23.6927 12.5002 22.7607 10.2501 21.1017 8.59104C19.4427 6.93203 17.1926 6 14.8464 6C12.5002 6 10.2501 6.93203 8.59104 8.59104C6.93203 10.2501 6 12.5002 6 14.8464C6 17.1926 6.93203 19.4427 8.59104 21.1017C10.2501 22.7607 12.5002 23.6927 14.8464 23.6927Z"
        stroke="#666666"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1479 8.21161V21.4812"
        stroke="#666666"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.1638 10.6242H13.6401C13.0802 10.6242 12.5432 10.8467 12.1473 11.2426C11.7514 11.6385 11.529 12.1754 11.529 12.7353C11.529 13.2952 11.7514 13.8322 12.1473 14.2281C12.5432 14.624 13.0802 14.8464 13.6401 14.8464H16.6559C17.2158 14.8464 17.7527 15.0688 18.1486 15.4647C18.5445 15.8606 18.7669 16.3975 18.7669 16.9574C18.7669 17.5173 18.5445 18.0543 18.1486 18.4502C17.7527 18.8461 17.2158 19.0685 16.6559 19.0685H11.529"
        stroke="#666666"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ShareIcon = ({ color = '#000000' }) => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M7.93122 22H7.911C7.78213 21.9957 7.65919 21.9442 7.56504 21.855C7.47088 21.7659 7.41191 21.6452 7.39908 21.5154C7.38152 21.3215 6.93507 16.679 9.75803 13.5064C11.3236 11.7462 13.5718 10.8045 16.4453 10.7022V8.53865C16.4453 8.4343 16.4752 8.33218 16.5315 8.24472C16.5878 8.15727 16.6679 8.08823 16.7622 8.04602C16.8565 8.00381 16.9609 7.99024 17.0627 8.00696C17.1645 8.02367 17.2593 8.06996 17.3356 8.14019L23.1891 13.5247C23.2439 13.5752 23.2878 13.6367 23.3178 13.7053C23.3478 13.7739 23.3633 13.8482 23.3633 13.9232C23.3633 13.9982 23.3478 14.0724 23.3178 14.141C23.2878 14.2097 23.2439 14.2712 23.1891 14.3216L17.3356 19.7062C17.2593 19.7764 17.1645 19.8227 17.0627 19.8394C16.9609 19.8561 16.8565 19.8426 16.7622 19.8004C16.6679 19.7581 16.5878 19.6891 16.5315 19.6017C16.4752 19.5142 16.4453 19.4121 16.4453 19.3077V17.1038C14.7872 16.9816 9.28656 16.9305 8.45484 21.5579C8.43253 21.682 8.3679 21.7942 8.27221 21.875C8.17652 21.9558 8.05584 22 7.93122 22ZM17.5096 9.75609V11.2309C17.5096 11.3737 17.4535 11.5107 17.3538 11.6117C17.254 11.7126 17.1186 11.7694 16.9775 11.7694C14.1625 11.7694 11.9999 12.5959 10.5488 14.2269C9.49312 15.4883 8.81426 17.0278 8.59159 18.6654C11.239 15.3485 16.9775 16.0711 17.0477 16.0808C17.1757 16.098 17.2931 16.1618 17.3781 16.2601C17.4631 16.3585 17.5098 16.4848 17.5096 16.6155V18.0903L22.0397 13.9232L17.5096 9.75609Z"
        fill={color}
      />
    </svg>
  );
};

export const Downloaded = ({ color = '#000000' }) => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M17.0678 13.8406C16.9172 13.6899 16.6722 13.6899 16.5215 13.8406L15.636 14.7261V6.38636C15.636 6.1731 15.4629 6 15.2496 6C15.0364 6 14.8633 6.1731 14.8633 6.38636V15.6588C14.8633 15.8149 14.9576 15.9563 15.102 16.0158C15.15 16.0359 15.2002 16.0451 15.2496 16.0451C15.3501 16.0451 15.449 16.0057 15.5224 15.9323L17.0678 14.3869C17.2185 14.2363 17.2185 13.9913 17.0678 13.8406Z"
        fill={color}
      />
      <path
        d="M15.5211 15.386L13.9757 13.8405C13.825 13.6899 13.5801 13.6899 13.4294 13.8405C13.2787 13.9912 13.2787 14.2362 13.4294 14.3869L14.9748 15.9323C15.0506 16.0072 15.1494 16.0451 15.2484 16.0451C15.3473 16.0451 15.4462 16.0072 15.5211 15.9323C15.6718 15.7816 15.6718 15.5366 15.5211 15.386Z"
        fill={color}
      />
      <path
        d="M23.6811 14.4742L20.8955 10.2954C20.3925 9.54129 19.551 9.09082 18.6454 9.09082H16.7948C16.5815 9.09082 16.4084 9.26392 16.4084 9.47718C16.4084 9.69045 16.5815 9.86355 16.7948 9.86355H18.6454C19.2921 9.86355 19.8933 10.185 20.2526 10.7236L23.0382 14.9023C23.2507 15.2207 23.3627 15.5916 23.3627 15.9741V21.0677C23.3627 21.7067 22.8427 22.2268 22.2037 22.2268H8.29502C7.65599 22.2268 7.13597 21.7067 7.13597 21.0677V16.0312C7.13597 15.6178 7.26502 15.223 7.52078 14.8729L10.0197 11.0805C10.522 10.3179 11.3665 9.86351 12.2783 9.86351H13.7039C13.9172 9.86351 14.0903 9.69041 14.0903 9.47715C14.0903 9.26388 13.9172 9.09082 13.704 9.09082H12.2783C11.1054 9.09082 10.0197 9.67574 9.3745 10.6555L6.88641 14.4325C6.54409 14.9 6.36328 15.4525 6.36328 16.0312V21.0677C6.36328 22.1325 7.23025 22.9994 8.29502 22.9994H22.2037C23.2684 22.9994 24.1354 22.1325 24.1354 21.0677V15.974C24.1354 15.4386 23.9786 14.9201 23.6811 14.4742Z"
        fill={color}
      />
      <path
        d="M23.3631 15.2725H21.4314C20.3666 15.2725 19.4996 16.1394 19.4996 17.2042C19.4996 17.8432 18.9796 18.3633 18.3406 18.3633H12.1589C11.5199 18.3633 10.9999 17.8432 10.9999 17.2042C10.9999 16.1394 10.1329 15.2725 9.06814 15.2725H7.13636C6.9231 15.2725 6.75 15.4456 6.75 15.6588C6.75 15.8721 6.9231 16.0452 7.13636 16.0452H9.0681C9.70714 16.0452 10.2272 16.5652 10.2272 17.2042C10.2272 18.269 11.0941 19.1359 12.1589 19.1359H18.3405C19.4053 19.1359 20.2723 18.269 20.2723 17.2042C20.2723 16.5652 20.7923 16.0452 21.4314 16.0452H23.3631C23.5764 16.0452 23.7495 15.8721 23.7495 15.6588C23.7495 15.4455 23.5764 15.2725 23.3631 15.2725Z"
        fill={color}
      />
    </svg>
  );
};

export const File = ({ color = '#000000' }) => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M21.5633 11.622C21.5673 11.3595 21.5195 11.0989 21.4228 10.8549C21.326 10.6109 21.1821 10.3884 20.9993 10.2L17.4893 6.6C17.3007 6.40988 17.0764 6.25898 16.8293 6.156C16.5821 6.05302 16.317 6 16.0493 6H10.3733C9.8402 6 9.32894 6.21177 8.952 6.58872C8.57505 6.96566 8.36328 7.47691 8.36328 8.01V21.99C8.36328 22.5231 8.57505 23.0343 8.952 23.4113C9.32894 23.7882 9.8402 24 10.3733 24H19.5533C19.8172 24 20.0786 23.948 20.3225 23.847C20.5663 23.746 20.7879 23.5979 20.9746 23.4113C21.1612 23.2246 21.3093 23.0031 21.4103 22.7592C21.5113 22.5153 21.5633 22.254 21.5633 21.99V11.622ZM19.5593 10.47H17.7053C17.6435 10.4752 17.5813 10.4678 17.5225 10.4482C17.4637 10.4286 17.4095 10.3972 17.3633 10.356C17.2789 10.2717 17.2314 10.1573 17.2313 10.038V8.082L19.5593 10.47ZM19.5593 22.8H10.3733C10.2667 22.8008 10.161 22.7804 10.0624 22.74C9.96373 22.6995 9.87412 22.6399 9.79874 22.5645C9.72337 22.4892 9.66374 22.3996 9.62331 22.3009C9.58289 22.2023 9.56248 22.0966 9.56328 21.99V8.01C9.56248 7.90341 9.58289 7.79772 9.62331 7.69908C9.66374 7.60045 9.72337 7.51084 9.79874 7.43546C9.87412 7.36009 9.96373 7.30045 10.0624 7.26003C10.161 7.21961 10.2667 7.1992 10.3733 7.2H16.0433V10.038C16.0433 10.2552 16.0862 10.4702 16.1695 10.6708C16.2527 10.8714 16.3748 11.0536 16.5287 11.2069C16.6825 11.3601 16.8651 11.4816 17.066 11.5641C17.2669 11.6467 17.4821 11.6888 17.6993 11.688L20.3633 11.658V21.99C20.3641 22.0966 20.3437 22.2023 20.3032 22.3009C20.2628 22.3996 20.2032 22.4892 20.1278 22.5645C20.0524 22.6399 19.9628 22.6995 19.8642 22.74C19.7656 22.7804 19.6599 22.8008 19.5533 22.8H19.5593Z"
        fill={color}
      />
      <path
        d="M17.3648 13.3438H12.5648C12.4057 13.3438 12.2531 13.407 12.1406 13.5195C12.0281 13.632 11.9648 13.7846 11.9648 13.9437C11.9648 14.1029 12.0281 14.2555 12.1406 14.368C12.2531 14.4805 12.4057 14.5437 12.5648 14.5437H17.3648C17.524 14.5437 17.6766 14.4805 17.7891 14.368C17.9016 14.2555 17.9648 14.1029 17.9648 13.9437C17.9648 13.7846 17.9016 13.632 17.7891 13.5195C17.6766 13.407 17.524 13.3438 17.3648 13.3438Z"
        fill={color}
      />
      <path
        d="M17.3648 17.2617H12.5648C12.4057 17.2617 12.2531 17.3249 12.1406 17.4375C12.0281 17.55 11.9648 17.7026 11.9648 17.8617C11.9648 18.0208 12.0281 18.1735 12.1406 18.286C12.2531 18.3985 12.4057 18.4617 12.5648 18.4617H17.3648C17.524 18.4617 17.6766 18.3985 17.7891 18.286C17.9016 18.1735 17.9648 18.0208 17.9648 17.8617C17.9648 17.7026 17.9016 17.55 17.7891 17.4375C17.6766 17.3249 17.524 17.2617 17.3648 17.2617Z"
        fill={color}
      />
    </svg>
  );
};

export const Todo = ({ color = '#000000' }) => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M20.4922 8.10938H18.8195C18.6018 7.49558 18.0156 7.05469 17.3281 7.05469H16.7104C16.4928 6.44082 15.9063 6 15.2188 6C14.5312 6 13.9447 6.44082 13.7271 7.05469H13.1094C12.4219 7.05469 11.8357 7.49558 11.618 8.10938H9.94531C9.07298 8.10938 8.36328 8.81907 8.36328 9.69141V22.418C8.36328 23.2903 9.07298 24 9.94531 24H20.4922C21.3645 24 22.0742 23.2903 22.0742 22.418V9.69141C22.0742 8.81907 21.3645 8.10938 20.4922 8.10938ZM12.582 8.63672C12.582 8.34594 12.8186 8.10938 13.1094 8.10938H14.1641C14.4553 8.10938 14.6914 7.87327 14.6914 7.58203C14.6914 7.29125 14.928 7.05469 15.2188 7.05469C15.5095 7.05469 15.7461 7.29125 15.7461 7.58203C15.7461 7.87327 15.9822 8.10938 16.2734 8.10938H17.3281C17.6189 8.10938 17.8555 8.34594 17.8555 8.63672V9.16406H12.582V8.63672ZM21.0195 22.418C21.0195 22.7087 20.783 22.9453 20.4922 22.9453H9.94531C9.65454 22.9453 9.41797 22.7087 9.41797 22.418V9.69141C9.41797 9.40063 9.65454 9.16406 9.94531 9.16406H11.5273V9.69141C11.5273 9.98264 11.7635 10.2188 12.0547 10.2188H18.3828C18.674 10.2188 18.9102 9.98264 18.9102 9.69141V9.16406H20.4922C20.783 9.16406 21.0195 9.40063 21.0195 9.69141V22.418Z"
        fill={color}
      />
      <path
        d="M14.5369 15.1896C14.331 14.9837 13.9971 14.9837 13.7912 15.1896L12.0547 16.9261L11.3729 16.2443C11.167 16.0383 10.8331 16.0383 10.6271 16.2443C10.4212 16.4502 10.4212 16.7841 10.6271 16.99L11.6818 18.0448C11.7848 18.1477 11.9197 18.1992 12.0547 18.1992C12.1897 18.1992 12.3246 18.1477 12.4276 18.0448L14.5369 15.9354C14.7429 15.7294 14.7429 15.3956 14.5369 15.1896Z"
        fill={color}
      />
      <path
        d="M14.5369 11.4987C14.331 11.2928 13.9971 11.2928 13.7912 11.4987L12.0547 13.2352L11.3729 12.5533C11.167 12.3474 10.8331 12.3474 10.6271 12.5533C10.4212 12.7593 10.4212 13.0932 10.6271 13.2991L11.6818 14.3538C11.7848 14.4568 11.9197 14.5083 12.0547 14.5083C12.1897 14.5083 12.3246 14.4568 12.4276 14.3538L14.5369 12.2445C14.7429 12.0385 14.7429 11.7046 14.5369 11.4987Z"
        fill={color}
      />
      <path
        d="M14.5369 18.8796C14.331 18.6736 13.9971 18.6736 13.7912 18.8796L12.0547 20.6161L11.3729 19.9343C11.167 19.7283 10.8331 19.7283 10.6271 19.9343C10.4212 20.1402 10.4212 20.4741 10.6271 20.68L11.6818 21.7347C11.7848 21.8377 11.9197 21.8892 12.0547 21.8892C12.1897 21.8892 12.3246 21.8377 12.4276 21.7347L14.5369 19.6253C14.7429 19.4194 14.7429 19.0855 14.5369 18.8796Z"
        fill={color}
      />
      <path
        d="M19.4375 12.3984H16.2734C15.9822 12.3984 15.7461 12.6345 15.7461 12.9258C15.7461 13.217 15.9822 13.4531 16.2734 13.4531H19.4375C19.7287 13.4531 19.9648 13.217 19.9648 12.9258C19.9648 12.6345 19.7287 12.3984 19.4375 12.3984Z"
        fill={color}
      />
      <path
        d="M19.4375 19.7812H16.2734C15.9822 19.7812 15.7461 20.0174 15.7461 20.3086C15.7461 20.5998 15.9822 20.8359 16.2734 20.8359H19.4375C19.7287 20.8359 19.9648 20.5998 19.9648 20.3086C19.9648 20.0174 19.7287 19.7812 19.4375 19.7812Z"
        fill={color}
      />
      <path
        d="M19.4375 16.0913H16.2734C15.9822 16.0913 15.7461 16.3274 15.7461 16.6187C15.7461 16.9099 15.9822 17.146 16.2734 17.146H19.4375C19.7287 17.146 19.9648 16.9099 19.9648 16.6187C19.9648 16.3274 19.7287 16.0913 19.4375 16.0913Z"
        fill={color}
      />
    </svg>
  );
};

const SelectDownIcon = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.825889 0.695695C0.984164 0.534246 1.23184 0.519569 1.40637 0.651664L1.45637 0.695695L5.02865 4.33977L8.60092 0.695695C8.7592 0.534246 9.00687 0.519569 9.1814 0.651664L9.2314 0.695695C9.38968 0.857144 9.40407 1.10979 9.27457 1.28781L9.2314 1.33882L5.34388 5.3043C5.18561 5.46575 4.93794 5.48043 4.76341 5.34834L4.71341 5.3043L0.825889 1.33882C0.651787 1.16123 0.651787 0.873289 0.825889 0.695695Z"
        fill="#112347"
      />
    </svg>
  );
};

const getPropertyAddress = (item) => {
  if (!item) return '';
  if (typeof item === 'string') return item;
  return (
    item?.pa_addressTwo ||
    item?.address ||
    item?.streetName ||
    item?.pa_addressState ||
    item?.propertyAddress?.streetName ||
    (typeof item?.propertyAddress === 'string' ? item?.propertyAddress : '') ||
    item?.property?.propertyAddress?.streetName ||
    item?.pa_address ||
    item?.property?.pa_addressTwo ||
    ''
  );
};

export const ExpandedCardOfferDetails = ({
  data,
  popover,
  handleClosePopover,
  isSmall,
  marketShow,
  expandFeedback,
  setExpandFeedback,
  propertyValue,
  show,
  expand,
  setExpand,
  ownercardprop,
  buyerId,
  activitywidth,
  buyercardcontact,
  rowData,
  buyerpropertylist,
  proid,
  setProid,
  userEmail,
  userType,
  proUniqueId,
  setProUniqueId,
  action,
  handleOptionChange,
  ownercardpopover,
  selectedPaAddressTwo,
  setSelectedPaAddressTwo,
  openbuyermatch,
  opendialog,
  username,
  handleBlueline,
  pipelineCat,
  isPipelineCat,
  setIsPipelineCat,
  setAction,
  setPipelineCat,
  Propertylist,
  pipelineId,
  setPipelineId,
  isAppraisal,
  setIsAppraisal,
  fromSearch,
  catSelected,
  noteSelected,
  taskId,
  taskBinderId,
  address,
  onOpenAutomatedStage,
  onOpenIncompleteDetails,
  refreshPipeline,
  isPipelineManagement,
}) => {
  function CircularProgressWithProfile(props) {
    return (
      <Box
        sx={{
          position: 'relative',
          display: 'inline-flex',
          marginLeft: '20px',
        }}
      >
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={38}
        />
        <CircularProgress
          variant="determinate"
          // value={props.value}
          value={props.value * 10}
          sx={{
            color: '#10D35E',
            position: 'absolute',
          }}
          thickness={5}
          size={38}
        />
        <Box
          sx={{
            top: '50%',
            left: '53%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{
              color: '#000000',
              ...poppins500,
              fontSize: '12px',
              paddingRight: '17px',
              display: 'flex',
              textAlign: 'center',
              justifyContent: 'center',
              fontWeight: matchessm ? 400 : 'auto',
            }}
          >
            {props.value}
          </Typography>
        </Box>
           
      </Box>
    );
  }

  const [openMovePipelineConfirm, setOpenMovePipelineConfirm] = useState(false);

  const { realTimeLog } = useContext(datacontext);
  useEffect(() => {
    getdata();
    if (isPipelineManagement) {
      Propertylist('pipeline');
      getAllCat();
      refreshPipeline?.();
      updatePipelineProperty();
    }
  }, [realTimeLog, buyerId]);

  const aId = JSON.parse(localStorage.getItem('userDetail')).userId;

  const [subOptions, setSubOptions] = useState([]);
  const [pipelines, setPipelines] = useState([]);

  const [currentStageOrder, setCurrentStageOrder] = useState(0);

  const getAllCat = () => {
    const params = { agentId: aId };

    getApiCall(PIPELINE_CATEGORY, params)
      .then((res) => {
        if (res.data?.status === -1) {
          toast.error(res.data.message, {
            position: 'top-right',
            autoClose: 2000,
            style: {
              fontFamily: 'Poppins', // 👈 Inline Poppins font
            },
          });
          return;
        }

        const formattedPipelines = res.data?.pipelineList.map((pipeline) => ({
          pipelineId: Number(pipeline.pipelineId),
          pipelineName: pipeline.pipelineName,
          subOptions: pipeline.categories.map((category) => ({
            categoryId: Number(category.categoryId),
            categoryName: category.categoryName,
          })),
        }));

        setPipelines(formattedPipelines);

        const defaultCategories = res.data.pipelineList[0];

        const selPipeline =
          isPipelineCat == 1 && pipelineId == 0
            ? defaultCategories
            : res?.data?.pipelineList?.find(
                (pipeline) => pipeline.pipelineId == pipelineId
              );

        const fetchedCategories = selPipeline.categories || [];

        const categoryMap = new Map(
          fetchedCategories.map((category) => [
            Number(category.categoryId),
            category.categoryOrder,
          ])
        );

        setSubOptions(
          fetchedCategories.map((category) => ({
            value: category.categoryId,
            label: category.categoryName,
            order: category.categoryOrder,
          }))
        );
        setCurrentStageOrder(categoryMap.get(Number(pipelineCat)) || 0);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getAllCat();
    updatePipelineProperty();
  }, [
    proid,
    isPipelineCat,
    pipelineCat,
    buyerpropertylist,
    pipelineId,
    isAppraisal,
  ]);

  const [newActiveValue, setActiveValue] = React.useState(0);
  const handleActiveChange = (event, newActiveValue) => {
    setActiveValue(newActiveValue);
  };
  function b11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const [makeOfferListArray, setMakeOfferListArray] = useState({});

  const groupCall = () => {
    getlistMakeOffer(proid).then((res) => {
      if (res?.status == 1) {
        setMakeOfferListArray(res?.conditionlist);
      } else {
        setMakeOfferListArray([]);
      }
    });
  };
  useEffect(() => {
    {
      !ownercardprop && groupCall();
    }
  }, []);

  const params = useParams();
  const [expandData, setExpandData] = useState({});
  const [selproperty, setSelproperty] = useState(proid);
  const getdata = () => {
    let endpoint;
    if (buyercardcontact) {
      endpoint =
        GetBuyerExpandRight + `?buyerId=${buyerId}&propertyId=${proid}`;
    } else {
      endpoint =
        GetBuyerExpandRight + `?buyerId=${buyerId}&propertyId=${proid}`;
    }
    getApiCall(endpoint).then((res) => {
      if (res?.data?.status == 1) {
        setExpandData(res?.data);
      }
    });
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClicke = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosee = () => {
    setAnchorEl(null);
  };

  const openn = Boolean(anchorEl);
  const id = openn ? 'simple-popover' : undefined;

  const [ownerExpandData, setownerExpandData] = useState();
  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const getownerdata = () => {
    const selectedProp = buyerpropertylist?.find((item) => item.pd_Id == proid);
    const isPipeline = selectedProp ? selectedProp.isPipelineProperty ?? 0 : 0;
    getApiCall(
      OWNERCARD_RIGHT + `?propertyId=${proid}` + `&isPipeline=${isPipeline}`
    ).then((res) => {
      if (res?.data?.status == 1) {
        setownerExpandData(res?.data);
      }
    });
  };
  useEffect(() => {
    if (ownercardprop) {
      getownerdata();
    } else {
      getdata();
    }
  }, [proid, marketShow, buyerpropertylist]);

  const [selectedProperty, setSelectedProperty] = useState(null);
  useEffect(() => {
    if (selproperty && buyerpropertylist.length >= 1) {
      const property = buyerpropertylist.find(
        (item) => item?.pd_Id === selproperty
      );
      setSelectedProperty(property);
    }
  }, [selproperty, buyerpropertylist]);

  // useEffect(() => {
  //   if (buyerpropertylist && buyerpropertylist.length > 0) {
  //     setSelproperty(buyerpropertylist[0]?.pd_Id);
  //   }
  // }, [buyerpropertylist]);

  const [locationMenu, setLocationMenu] = useState(false);

  const closeMenu = () => {
    return setLocationMenu(false);
  };
  const displayAddress = selectedPaAddressTwo
    ? selectedPaAddressTwo
    : selproperty;
  const Address =
    buyerpropertylist.length >= 1
      ? getPropertyAddress(
          buyerpropertylist?.find((item) => item?.pd_Id == displayAddress)
        )
      : '';

  const updatePipelineProperty = () => {
    if (buyerpropertylist && buyerpropertylist.length >= 1) {
      buyerpropertylist?.map((item) => {
        if (item.pd_Id == proid) {
          setPipelineId(item?.pd_pipelineId ?? null);
          setPipelineCat(item?.pd_categoryId ?? null);
          setIsPipelineCat(item?.isPipelineProperty ?? null);
          setIsAppraisal(item?.pd_isAppraisal ?? null);
        }
      });
    }
  };

  const handleChange = (event) => {
    setLocationMenu(false);
    let values;
    if (buyerpropertylist && buyerpropertylist.length > 1) {
      buyerpropertylist?.map((item) => {
        if (item.pd_Id == event.target.value) {
          values = item?.pd_propertyId;
        }
      });
    }
    const selectedPropertyId = event.target.value;
    setSelproperty(selectedPropertyId);
    setProid(selectedPropertyId);
    setProUniqueId(values);
    setSelectedPaAddressTwo('');
    handleBlueline(selectedPropertyId);
  };

  function CircularProgressexpanded(props) {
    const size = matchessm ? 78 : matches1000 ? 80 : 100;
    const thickness = matchessm ? 3 : 5;

    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        {/* Background Progress */}
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={thickness}
          size={size}
        />

        {/* Gradient Progress */}
        <CircularProgress
          variant="determinate"
          value={props.value}
          thickness={thickness}
          size={size}
          style={{
            color: 'transparent',
            position: 'absolute',
            // Make the default color transparent
          }}
          classes={{
            circle: 'custom-gradient-circle', // Apply custom class for gradient
          }}
        />
        <Box
          sx={{
            width: `${thickness + thickness - 1}px`,
            height: `${thickness + thickness - 1}px`,
            borderRadius: '50%',
            backgroundColor: 'white',
            position: 'absolute',
            top: `calc(50% - ${size / 2 - 0.5}px)`,
            left: `calc(50% - ${thickness - 0.5}px)`,
          }}
        />
        {/* Text or Avatar */}
        <Box
          sx={{
            top: '50%',
            left: '53%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{
              color: '#000000',
              ...poppins400,
              fontSize: matchessm ? '12px' : matches1000 ? '12px' : '14px',
            }}
          >
            {Math.round(props?.value * 100) / 100}%
          </Typography>
        </Box>

        {/* Gradient Styles */}
        <style>
          {`
            .custom-gradient-circle {
              stroke: url(#gradient);
              stroke-linecap: round; /* Make ends rounded */
            }
          `}
        </style>
        <svg width="0" height="0">
          <defs>
            <linearGradient id="gradient" x1="1" x2="0" y1="0" y2="0">
              <stop offset="0%" stopColor="#5FB1DF" />
              <stop offset="100%" stopColor="#5FB1DF" />
            </linearGradient>
          </defs>
        </svg>
      </Box>
    );
  }
  const BlurredBackground = styled('div')({
    position: 'fixed',
    top: 586,
    left: 947,
    width: '46%',
    height: '50%',
    backdropFilter: 'blur(5px)',
    zIndex: 1,
  });
  const theme = useTheme();
  const matchesmdxl = useMediaQuery(theme.breakpoints.between(500));
  const isXs = useMediaQuery((theme) => theme.breakpoints.only('xs'));
  const isSm = useMediaQuery((theme) => theme.breakpoints.only('sm'));
  const isMd = useMediaQuery((theme) => theme.breakpoints.only('md'));
  const isLg = useMediaQuery((theme) => theme.breakpoints.only('lg'));
  const isXl = useMediaQuery((theme) => theme.breakpoints.only('xl'));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const matches1920 = useMediaQuery(theme.breakpoints.down(1920));
  const matches1000 = useMediaQuery(theme.breakpoints.down(1000));
  const matches1100 = useMediaQuery(theme.breakpoints.down(1100));
  const matches1200 = useMediaQuery(theme.breakpoints.down(1200));
  const matches1850 = useMediaQuery(theme.breakpoints.down(1850));
  const matches1800 = useMediaQuery(theme.breakpoints.down(1800));
  const matches1600 = useMediaQuery(theme.breakpoints.down(1600));
  const matches1700 = useMediaQuery(theme.breakpoints.down(1700));
  const matches1450 = useMediaQuery(theme.breakpoints.down(1450));
  const matches1400 = useMediaQuery(theme.breakpoints.down(1400));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches870 = useMediaQuery(theme.breakpoints.down(870));
  const matches650 = useMediaQuery(theme.breakpoints.down(650));
  const matches600 = useMediaQuery(theme.breakpoints.down(600));
  const matches530 = useMediaQuery(theme.breakpoints.down(530));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches400 = useMediaQuery(theme.breakpoints.down(400));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const selectRef = useRef(null);
  const [pipeAnchorEl, setPipeAnchorEl] = useState(null);
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState(null);
  const [selectedPipeline, setSelectedPipeline] = useState(null);
  const [selectedPipeCategory, setSelectedPipeCategory] = useState(null);
  // const [action, setAction] = useState("");
  const handlePipelineClick = (event) => {
    setAction('Add to Pipeline');
    setPipeAnchorEl(selectRef.current);
  };

  // ✅ Open sub-options menu next to the pipeline
  const handlePipelineSelect = (event, pipeline) => {
    setSelectedPipeline(pipeline);
    setSubMenuAnchorEl(event.currentTarget); // ✅ Ensure sub-options appear next to pipeline
  };

  // ✅ Select category and close menus
  const handleCategorySelect = (category) => {
    if (category.categoryName === 'Listed') {
      handleCloseSuboptionPopover();
      onOpenIncompleteDetails?.({
        movedOrder: {
          id: proid,
          propertyId: proid,
        },
        categoryId: category.categoryId,
      });
      return;
    }

    const restrictedStages = ['Under Offer', 'Exchanged', 'Settled'];

    if (restrictedStages.includes(category.categoryName)) {
      handleCloseSuboptionPopover();
      onOpenAutomatedStage?.(category.categoryName);
      return;
    }
    setSelectedPipeCategory(category);
    handleCloseSuboptionPopover();
    setOpenMovePipelineConfirm(true);
  };

  const handleClosePipelineMenu = () => {
    setPipeAnchorEl(null);
  };

  // ✅ Close only the sub-options menu
  const handleCloseSubOptionsMenu = () => {
    setSubMenuAnchorEl(null);
  };

  const handleConfirmMove = async () => {
    setOpenMovePipelineConfirm(false);
    const params = {
      propertyId: proid,
      categoryId: Number(selectedPipeCategory?.categoryId),
      pipelineId: Number(selectedPipeline?.pipelineId),
    };

    try {
      const res = await postApiCall(PIPELINE_REORDERPROPERTY_CATEGORY, params);
      if (res.data?.status === -1) {
        toast.error(res.data.message, {
          position: 'top-right',
          autoClose: 2000,
          style: {
            fontFamily: 'Poppins', // 👈 Inline Poppins font
          },
        });
        // setPopoverAnchorEl(null);
        setAction('');
      } else {
        Propertylist('pipeline');
        getAllCat();
        refreshPipeline?.();
        updatePipelineProperty();
        Swal.fire({
          title: res?.data?.heading,
          text: res?.data?.message,
          showConfirmButton: true,
          icon: 'success',
          confirmButtonText: 'Close',
          reverseButtons: true,
        });
      }
    } catch (err) {
      console.error(err);
    }

    setAction('');
    setPipeAnchorEl(null);
    setSubMenuAnchorEl(null);
  };

  const handleCloseSuboptionPopover = () => {
    setSubMenuAnchorEl(null);
    setPipeAnchorEl(null);
    setAction('');
  };

  const ArrowBox = ({
    label,
    textColor = 'textColor',
    fillColor = 'lightblue',
  }) => {
    return (
      <svg
        viewBox="0 0 392 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: '100%', height: 'auto' }} // Full width and maintain aspect ratio
      >
        <g filter="url(#filter0_d_31666_188611)">
          <path
            d="M373.973 46H7L20.2322 26L7 6H373.973L385 27.2121L373.973 46Z"
            fill={fillColor}
          />
          <path
            d="M373.973 46H7L20.2322 26L7 6H373.973L385 27.2121L373.973 46Z"
            stroke="#6C2AD2"
          />
        </g>
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontSize="18px"
        >
          {label}
        </text>
        <defs>
          <filter
            id="filter0_d_31666_188611"
            x="0.0693359"
            y="0.5"
            width="391.502"
            height="53"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_31666_188611"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_31666_188611"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  };

  const restrictedStages = ['Listed', 'Under Offer', 'Exchanged', 'Settled'];

  return (
    <>
      <Grid
        sx={{
          display: 'flex',
          marginTop: popover || ownercardpopover ? '-55px' : '-50px',
          justifyContent: 'right',
          // width: isLg ? "90%" : isSm || isXs ? "98%" : isMd ? "85%" : "98%"
          //border:"1px solid red",
          width: popover || ownercardpopover ? '50px' : '98%',
          marginLeft:
            popover && matches400
              ? '88%'
              : popover && matches500
              ? '88%'
              : popover && matches600
              ? '89%'
              : popover && matches650
              ? '90%'
              : popover && matches870
              ? '93%'
              : ownercardpopover && matches400
              ? '83%'
              : ownercardpopover && matches500
              ? '85%'
              : ownercardpopover && matches650
              ? '87%'
              : ownercardpopover && matches750
              ? '89%'
              : ownercardpopover && matches870
              ? '91%'
              : '',
        }}
      >
        {!matchessm && (
          <IconButton
            onClick={() => {
              if (popover || ownercardpopover) {
                handleClosePopover();
              } else {
                setExpand(!expand);
              }
              // setIsHidden(false);
            }}
            sx={{ paddingRight: 0 }}
          >
            <RightArrow />
          </IconButton>
        )}
      </Grid>
      {ownercardprop && (
        <Grid
          width={matchessm ? '100%' : '95%'}
          marginLeft={matchessm ? 0 : 2}
          mb={matchessm ? 0 : 1}
          container
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'left',
            alignItems: 'left',
          }}
        >
          {isPipelineCat == 1 &&
            isAppraisal == 1 &&
            subOptions.map((option, index) => (
              <Box
                sx={{
                  position: 'relative',
                  padding: 0,
                  width: '100%',
                  maxWidth: matchessm ? '100%' : matches1450 ? 120 : 220,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // height:"50px"
                }}
              >
                <ArrowBox
                  label={option.label}
                  textColor={
                    option.order <= currentStageOrder ? 'white' : '#6C2AD2'
                  }
                  fillColor={
                    option.order <= currentStageOrder ? '#6C2AD2' : 'white'
                  }
                />
              </Box>
            ))}
        </Grid>
      )}
      {!matchessm && (ownercardpopover || popover) && (
        <Grid
          sx={{
            width: isSm ? '100%' : '98%',
            display: 'flex',
            justifyContent: 'center',
            ml: '20px',
          }}
        >
          <Typography
            sx={{ ...poppins500, fontSize: '14px', color: '#585858' }}
          >
            {username?.userName}&nbsp;{username?.userSurName}
          </Typography>
        </Grid>
      )}
      {!marketShow && (
        <Grid
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: matchessm ? '25px 5px' : '25px 20px',
            gap: '10px',
            // width: window.innerWidth < 600 ? "92%" : isXl ? "99%" : window.innerWidth <= 1150 ? "80%" : window.innerWidth <= 1450 ? "92%" : "98%",
            // width: isLg ? "90%" : isSm || isXs ? "98%" : isMd ? "85%" : "98%",
            width:
              isPipelineManagement && ownercardprop
                ? '97.5%'
                : ownercardprop && show && matches1600
                ? '94%'
                : matchessm
                ? '100%'
                : 'auto',
            borderRadius: '8px',
            // p: "25px, 20px, 25px, 20px",
            background: '#FFFFFF',
            // background:'pink',
            //border:"2px solid blue",
            marginTop: matchessm ? '10px' : 'auto',
            border: '1px solid #E7E5E5',
            marginLeft:
              isPipelineManagement && ownercardprop
                ? '30px'
                : matchessm
                ? '0px'
                : ownercardprop && matches1000
                ? 'none'
                : (ownercardprop && matches1400) ||
                  ((isMd || isSm || isXs) && !ownercardprop)
                ? '10px'
                : 'none',
          }}
        >
          <Grid
            sx={{
              display: ' flex',
              flexDirection: ' column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              padding: '0px',
              gap: '20px',
              width: '100%',
              // height: " 212px",
            }}
          >
            <Grid
              container
              sx={{
                display: 'flex',
                flexDirection:
                  isXs || isSm || isMd || isLg || (ownercardprop && matches1700)
                    ? 'column'
                    : 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                flexWrap: 'nowrap',
                overflow: 'hidden',
                padding: '0px',
                // width: matchesmdxl ? "42.2%" : "96.2%",
                // gap: window.innerWidth <= 1550 ? "5px" : null
                // background:'pink',
              }}
            >
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'start',
                  alignItems: 'center',
                  padding: '0px',
                  // gap: "15px",
                  // width:  window.innerWidth <= 1550 ? "100%" : "88%",
                  width:
                    (isXs || isSm || isMd || isLg) && !ownercardprop
                      ? '90%'
                      : ownercardprop && matches1700
                      ? '100%'
                      : 'auto',
                  maxWidth:
                    (isXs || isSm || isMd || isLg) && !ownercardprop
                      ? '90%'
                      : ownercardprop && matches1700
                      ? '100%'
                      : '58%',
                  // marginLeft:window.innerWidth <= 1250 ?'20%' : "0px",
                  // height: " 36px",
                  // backgroundColor:"black"
                  whiteSpace: 'nowrap',
                  minWidth: 0,
                  mr: (isXs || isSm || isMd || isLg) ? 0 : 2,
                }}
              >
                <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                  <Location width={30} height={30} />
                </Box>
                <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    minWidth: 0,
                    maxWidth: '100%',
                  }}
                >
                  <Tooltip
                    title={
                      (buyerpropertylist &&
                        selproperty &&
                        getPropertyAddress(
                          buyerpropertylist?.find(
                            (item) => item?.pd_Id == displayAddress
                          )
                        )) ||
                      ''
                    }
                    placement="bottom"
                    disableInteractive
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: '#fafafa',
                          boxShadow: '0px 2px 20px lightgray',
                          color: 'black',
                          padding: '10px',
                          fontFamily: 'poppins !important',
                          fontSize: '14px',
                          maxWidth: '1000px',
                        },
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        ...poppins500,
                        fontSize: window.innerWidth < 960 ? '16px' : '24px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        minWidth: 0,
                        flexShrink: 1,
                        pl: 1,
                      }}
                    >
                      {buyerpropertylist?.find(
                        (item) => item?.pd_Id == displayAddress
                      )
                        ? getPropertyAddress(
                            buyerpropertylist?.find(
                              (item) => item?.pd_Id == displayAddress
                            )
                          )
                        : ownercardprop
                        ? getPropertyAddress(ownerExpandData?.data?.address)
                        : getPropertyAddress(expandData?.data?.address)}
                      {/* {
                        buyerpropertylist?.find(
                          (item) => item?.pd_Id == displayAddress
                        )?.pa_addressTwo
                      }  */}
                    </Typography>
                  </Tooltip>
                  <Select
                    onChange={handleChange}
                    open={locationMenu}
                    onClose={closeMenu}
                    sx={{ width: 0, height: 0, opacity: 0, p: 0 }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          overflowX: 'scroll',
                        },
                      },
                    }}
                  >
                    {buyerpropertylist?.map((value) => (
                      <MenuItem key={value?.pd_Id} value={value?.pd_Id}>
                        {value?.streetName}
                      </MenuItem>
                    ))}
                  </Select>
                  <IconButton
                    onClick={() => setLocationMenu(!locationMenu)}
                    sx={{ flexShrink: 0, p: 0.5 }}
                  >
                    <ArrowDropDownRoundedIcon fontSize="large" />
                  </IconButton>
                </Box>
              </Grid>
              {rowData?.buyerOfferDetails &&
                rowData?.buyerOfferDetails != '' &&
                matchessm && (
                  <>
                    <Grid
                      container
                      sx={{
                        dsiplay: 'flex',
                        flexDirection: 'row',
                        gap: '15px',
                        width: matchessm ? '100%' : 'auto',
                        justifyContent: matchessm ? 'space-around' : 'auto',
                      }}
                    >
                      <Grid item>
                        <div>
                          <BadgeButton
                            row={rowData}
                            offerStatus={
                              rowData?.buyerOfferDetails?.offerStatus
                            }
                            offerStatusVendor={
                              rowData?.buyerOfferDetails?.offerStatusVendor
                            }
                            isnew={rowData?.buyerOfferDetails?.isNew}
                            matchessm={matchessm}
                          />
                        </div>
                      </Grid>
                      {!rowData?.buyerOfferDetails?.offerStatusVendor ||
                        (rowData?.buyerOfferDetails?.offerStatusVendor !=
                          null && (
                          <Grid item>
                            <Typography
                              sx={{
                                padding: '3px 10px',
                                border: `1px solid ${getColor(
                                  rowData?.buyerOfferDetails?.offerStatusVendor
                                )}`,
                                borderRadius: '17px',
                                width: '125px',
                                flexWrap: 'nowrap',
                                whiteSpace: 'nowrap',
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '300 !important',
                                fontSize: '12px !important',
                                color: getColor(
                                  rowData?.buyerOfferDetails?.offerStatusVendor
                                ),
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                                gap: 0.5,
                              }}
                            >
                              <WarningLite
                                color={getColor(
                                  rowData?.buyerOfferDetails?.offerStatusVendor
                                )}
                              />
                              {rowData?.buyerOfferDetails?.offerStatusVendor}
                            </Typography>
                          </Grid>
                        ))}
                    </Grid>
                  </>
                )}
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  width:
                    ownercardprop && matches1700
                      ? '95%'
                      : ownercardprop && !matches1700
                      ? '35%'
                      : '',
                }}
              >
                {ownercardprop && (
                  <Grid
                    sx={{ width: ownercardprop && matches1700 ? '50%' : '20%' }}
                  >
                    <Box>
                      <Select
                        ref={selectRef}
                        sx={{
                          ...poppins500,
                          fontSize: '12px',
                          fontColor: '#112347',
                          border: '1px solid #6C2AD2',
                          width: '100px',
                          height: '30px',
                          borderRadius: '6px',
                          '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                          },
                        }}
                        // size="medium"
                        value={action}
                        style={{
                          padding: '0px',
                        }}
                        onChange={(e) => {
                          if (e.target.value == 'Add to Pipeline') {
                            // handleAddToPipelineChange(e);
                            // handlePipelineClick(e);
                          } else {
                            handleOptionChange(e, ownerExpandData?.debug);
                          }
                        }}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem
                          value={''}
                          sx={{
                            ...poppins500,
                            fontSize: '12px',
                            color: '#112347',
                          }}
                        >
                          Action
                        </MenuItem>
                        <MenuItem
                          value={10}
                          sx={{
                            ...poppins500,
                            fontSize: '12px',
                            color: '#112347',
                          }}
                        >
                          Insights
                        </MenuItem>
                        <MenuItem
                          value={20}
                          sx={{
                            ...poppins400,
                            fontSize: '12px',
                            color: '#112347',
                          }}
                        >
                          Buyer Match
                        </MenuItem>

                        {isPipelineCat == 1 && isAppraisal == 1 && (
                          <MenuItem
                            value="Add to Pipeline"
                            sx={{
                              ...poppins400,
                              fontSize: '12px',
                              color: '#112347',
                            }}
                            onClick={(event) => {
                              handlePipelineClick(event);
                            }}
                          >
                            {pipelineCat == 0
                              ? 'Add to Pipeline'
                              : 'Edit Pipeline'}
                          </MenuItem>
                        )}
                      </Select>

                      {/* using nested menuitem */}

                      <Menu
                        anchorEl={pipeAnchorEl}
                        open={Boolean(pipeAnchorEl)}
                        onClose={handleClosePipelineMenu}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'left',
                        }}
                      >
                        {pipelines.map((pipeline) => (
                          <MenuItem
                            sx={{
                              ...poppins500,
                              fontSize: '12px',
                              color: '#112347',
                              padding: '6px 12px',
                              '&:hover': { backgroundColor: '#f0f0f0' },
                            }}
                            key={pipeline.pipelineId}
                            onClick={(e) => handlePipelineSelect(e, pipeline)}
                          >
                            <ListItemText
                              disableTypography
                              primaryTypographyProps={{
                                sx: {
                                  ...poppins500,
                                  fontSize: '12px',
                                  color: '#112347',
                                },
                              }}
                              primary={pipeline.pipelineName}
                            />
                            <ListItemIcon>
                              <ArrowRightIcon />
                            </ListItemIcon>
                          </MenuItem>
                        ))}
                      </Menu>

                      {/* Sub-options Menu - Appears next to the selected pipeline */}
                      <Menu
                        anchorEl={subMenuAnchorEl} // ✅ Ensures it opens in the correct place
                        open={Boolean(subMenuAnchorEl)}
                        onClose={handleCloseSubOptionsMenu}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // ✅ Aligns correctly with pipeline selection
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'left',
                        }}
                        sx={{ ml: '5px' }}
                      >
                        <Typography
                          sx={{
                            px: 2,
                            pt: 1,
                            ...poppins400,
                            fontSize: '12px',
                            color: ' #666666',
                          }}
                        >
                          {pipelineCat == 0
                            ? 'Select Category'
                            : 'Edit Category'}
                        </Typography>

                        {selectedPipeline?.subOptions.map((subOption) => (
                          <MenuItem
                            sx={{
                              ...poppins500,
                              fontSize: '12px',
                              color: '#112347',
                              padding: '6px 12px',
                              '&:hover': { backgroundColor: '#f0f0f0' },
                            }}
                            key={subOption.categoryId}
                            onClick={() => handleCategorySelect(subOption)}
                            disabled={
                              (pipelineId == selectedPipeline.pipelineId &&
                                subOption.categoryId == pipelineCat) ||
                              (!isPipelineManagement &&
                                restrictedStages.includes(
                                  subOption.categoryName
                                ))
                            } // Condition to disable
                          >
                            {subOption.categoryName}
                          </MenuItem>
                        ))}
                      </Menu>
                    </Box>
                  </Grid>
                )}
                {ownercardprop && (
                  <Grid
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent:
                        window.innerWidth <= 1300 ? 'center' : 'flex-end',
                      // justifyContent:'flex-end',
                      alignItems: 'center',
                      padding: '0px',
                      gap: window.innerWidth <= 1300 ? '15px' : '12px',
                      marginTop: window.innerWidth <= 1300 ? '10px' : '0px',
                      // marginRight: window.innerWidth <=1250 ? "15%": "0px",
                      // width:  window.innerWidth <= 1550 ? "100%" : "90%",
                      width: ownercardprop && matches1700 ? '50%' : '30%',
                      // height: "30px",
                      flex: 2,
                    }}
                  >
                    {bed()}
                    <Typography
                      sx={{
                        fontStyle: 'poppins',
                        fontSize: '12px',
                        fontWeight: '400px',
                        color: '#000000',
                      }}
                    >
                      {
                        ownerExpandData?.debug?.propertyOtherDetails
                          ?.bedRoomCount
                      }
                    </Typography>
                    {shower()}
                    <Typography
                      sx={{
                        fontStyle: 'poppins',
                        fontSize: '12px',
                        fontWeight: '400px',
                        color: '#000000',
                      }}
                    >
                      {
                        ownerExpandData?.debug?.propertyOtherDetails
                          ?.bathRoomCount
                      }
                    </Typography>
                    {parkedcar()}
                    <Typography
                      sx={{
                        fontStyle: 'poppins',
                        fontSize: '12px',
                        fontWeight: '400px',
                        color: '#000000',
                      }}
                    >
                      {
                        ownerExpandData?.debug?.propertyOtherDetails
                          ?.otherCarParking
                      }
                    </Typography>
                  </Grid>
                )}
              </Grid>

              {!ownercardprop && (
                <Grid
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent:
                      window.innerWidth <= 1300 ? 'center' : 'flex-end',
                    // justifyContent:'flex-end',
                    alignItems: 'center',
                    padding: '0px',
                    gap: window.innerWidth <= 1300 ? '15px' : '8px',
                    marginTop: window.innerWidth <= 1300 ? '10px' : '0px',
                    // marginRight: window.innerWidth <=1250 ? "15%": "0px",
                    // width:  window.innerWidth <= 1550 ? "100%" : "90%",
                    width: isXs || isSm || isMd || isLg ? '100%' : '35%',
                    // height: "30px",
                  }}
                >
                  <EyeIcon
                    color={
                      expandData?.data?.flagInspected == 1
                        ? '#6C2AD2'
                        : '666666'
                    }
                  />
                  <Todo
                    color={
                      expandData?.data?.flagDueDiligence == 1
                        ? '#6C2AD2'
                        : '#666666'
                    }
                  />
                  <File
                    color={
                      expandData?.data?.flagViewContract == 1
                        ? '#6C2AD2'
                        : '#666666'
                    }
                  />
                  <FileCopy
                    color={
                      expandData?.data?.flagContractWithSolicitor == 1
                        ? '#6C2AD2'
                        : '#666666'
                    }
                  />
                  {/* <ShareIcon color={expandData?.data?.flagFrwdToSolicitor ? "#6C2AD2" : "#666666"}  /> */}
                  <Downloaded
                    color={
                      expandData?.data?.flag66w == 1 ? '#6C2AD2' : '#666666'
                    }
                  />
                  {expandData?.data?.flagSignContract == 1 ? (
                    <SignContractColor />
                  ) : (
                    <SignContract />
                  )}
                  {expandData?.data?.flagDepositPayment == 1 ? (
                    <DepositIconColor />
                  ) : (
                    <DepositIcon />
                  )}
                </Grid>
              )}
            </Grid>
            {rowData?.buyerOfferDetails &&
              rowData?.buyerOfferDetails != '' &&
              !matchessm && (
                <>
                  <Grid
                    container
                    sx={{
                      dsiplay: 'flex',
                      flexDirection: 'row',
                      gap: '15px',
                      width: matchessm ? '100%' : 'auto',
                      justifyContent: matchessm ? 'space-around' : 'auto',
                    }}
                  >
                    <Grid item>
                      <div>
                        <BadgeButton
                          row={rowData}
                          offerStatus={rowData?.buyerOfferDetails?.offerStatus}
                          offerStatusVendor={
                            rowData?.buyerOfferDetails?.offerStatusVendor
                          }
                          isnew={rowData?.buyerOfferDetails?.isNew}
                          matchessm={matchessm}
                        />
                      </div>
                    </Grid>
                    {!rowData?.buyerOfferDetails?.offerStatusVendor ||
                      (rowData?.buyerOfferDetails?.offerStatusVendor !=
                        null && (
                        <Grid item>
                          <Typography
                            sx={{
                              padding: '3px 10px',
                              border: `1px solid ${getColor(
                                rowData?.buyerOfferDetails?.offerStatusVendor
                              )}`,
                              borderRadius: '17px',
                              width: '125px',
                              flexWrap: 'nowrap',
                              whiteSpace: 'nowrap',
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '300 !important',
                              fontSize: '12px !important',
                              color: getColor(
                                rowData?.buyerOfferDetails?.offerStatusVendor
                              ),
                              justifyContent: 'center',
                              alignItems: 'center',
                              display: 'flex',
                              gap: 0.5,
                            }}
                          >
                            <WarningLite
                              color={getColor(
                                rowData?.buyerOfferDetails?.offerStatusVendor
                              )}
                            />
                            {rowData?.buyerOfferDetails?.offerStatusVendor}
                          </Typography>
                        </Grid>
                      ))}
                  </Grid>
                </>
              )}
            {ownercardprop &&
              ((isPipelineCat === 1 &&
                (isAppraisal === 1 || isAppraisal === 0)) ||
                ownerExpandData?.debug?.campaignType) && (
                <Grid container>
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '12px',
                        color: '#373737',
                        border: '1px solid #D9D9D9',
                        background: '#FFFFFF',
                        borderRadius: '5px',
                        padding: '5px 25px',
                        marginTop: '20px',
                        width: '120px',
                        height: '30px',
                        marginLeft: matchessm ? '8px' : '5px',
                      }}
                    >
                      {isPipelineCat === 1
                        ? isAppraisal === 1
                          ? 'Appraisal'
                          : 'Not Listed'
                        : ownerExpandData?.debug?.campaignType}
                    </Typography>
                  </Box>
                </Grid>
              )}

            <Stack
              sx={{
                display: 'flex',
                // flexDirection:'row',
                flexDirection:
                  ownercardpopover && matches650
                    ? 'column'
                    : ownercardpopover && matches870
                    ? 'row'
                    : popover && matches650
                    ? 'column'
                    : popover && matches870
                    ? 'row'
                    : matches1000
                    ? 'column'
                    : matches1400
                    ? 'row'
                    : isLg || isMd || isSm || isXs || matches1700
                    ? 'column'
                    : 'row',
                // alignItems: "flex-start",
                padding: '0px',
                // gap: "22px",
                justifyContent: 'space-between',
                // backgroundColor:"red",
                width: '100%',
                gap: matches1400 ? 2 : 5,
                // border: "3px solid yellow",
                // height: "156px",
                // marginTop:  window.innerWidth <= 1250 ? "25px" :"0px"
              }}
            >
              <Grid
                sx={{
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: ' column',
                  // alignItems: "flex-start",
                  padding: '10px 15px',
                  gap: '5px',
                  justifyContent: 'space-between',
                  // alignContent: "",
                  // width:  window.innerWidth <= 1550 ? "70%" : "48%",
                  width:
                    ownercardpopover && matches650
                      ? '100%'
                      : ownercardpopover && matches870
                      ? '50%'
                      : popover && matches870
                      ? '100%'
                      : matches1000
                      ? '100%'
                      : matches1400
                      ? '50%'
                      : isLg || isMd || isSm || isXs || matches1700
                      ? '100%'
                      : '50%',
                  // border: "1px solid red",
                  // height: "155.73px",
                  background: ' #F8F8F8',
                  borderRadius: '8px',
                }}
              >
                <Grid
                  sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    width: '100%',
                    mt: '5px',
                    // height: "24px",
                  }}
                >
                  <Grid sx={{ width: '50%' }}>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '14px',
                        color: '#585858',
                        fontWeight: matchessm ? 400 : 500,
                      }}
                    >
                      {ownercardprop ? 'Appraisal Date' : 'Current Offer'}
                    </Typography>
                  </Grid>
                  <Stack
                    direction={
                      popover && matches500
                        ? 'column'
                        : popover && matches650
                        ? 'row'
                        : popover && matches870
                        ? 'column'
                        : matches1000
                        ? 'row'
                        : matches1400
                        ? 'column'
                        : matches1700
                        ? 'row'
                        : matches1800
                        ? 'column'
                        : 'row'
                    }
                    justifyContent={'space-between'}
                    sx={{ width: '50%' }}
                  >
                    <Grid>
                      <Typography
                        sx={{
                          ...poppins400,
                          fontSize: '14px',
                          color: '#000000',
                          textAlign: 'center',
                          textTransform: 'capitalize',
                        }}
                      >
                        {' '}
                        {/* {ownercardprop ? "15 December 2022" : "$2,250,000"} */}
                        {ownercardprop
                          ? '-'
                          : `${'$'} ${(
                              expandData?.data?.currentOffer || 0
                            ).toLocaleString('en-US')}`}
                      </Typography>
                    </Grid>
                    {!ownercardprop && (
                      <Grid>
                        {expandData?.data?.noOfOffers !== 0 && (
                          <Typography
                            sx={{
                              ...poppins500,
                              background:
                                expandData?.data?.isConditional == 1
                                  ? 'rgba(237, 11, 11, 0.6)'
                                  : '#10D35E',
                              fontSize: '10px',
                              borderRadius: '5px',
                              color: '#FFFFFF',
                              padding: '4px 8px',
                            }}
                          >
                            {expandData?.data?.isConditional == 1
                              ? 'Conditional'
                              : 'Unconditional'}
                          </Typography>
                        )}
                      </Grid>
                    )}
                  </Stack>
                </Grid>
                <Grid
                  sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    // width: "98%",
                    width: '100%',
                    // height: "24px",
                    mt: '20px',
                  }}
                >
                  <Grid sx={{ width: '50%' }}>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '14px',
                        color: '#585858',
                        fontWeight: matchessm ? 400 : 500,
                      }}
                    >
                      {ownercardprop ? 'Estimated Value' : 'Number of Offers'}
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '14px',
                        color: '#000000',
                        textAlign: 'center',
                      }}
                    >
                      {/* {ownercardprop ? "$4,500,000" : "5"} */}
                      {ownercardprop
                        ? '-'
                        : `${expandData?.data?.noOfOffers || 0}`}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  sx={{
                    display: 'flex',
                    flexDirection:
                      ownercardpopover && matches530
                        ? 'column'
                        : ownercardpopover && matches650
                        ? 'row'
                        : ownercardprop && matches1400
                        ? 'column'
                        : ownercardprop && matches1700
                        ? 'row'
                        : ownercardprop && matches1920
                        ? 'column'
                        : 'row',
                    justifyContent: 'start',
                    alignItems: 'center',
                    mt: ownercardprop ? '25px' : '10px',
                    // width: "100%",
                    width: '100%',
                    // height: "47.37px",
                    // border: "1px solid yellow",
                  }}
                >
                  <Grid
                    sx={{
                      width:
                        ownercardpopover && matches530
                          ? '100%'
                          : ownercardpopover && matches650
                          ? '50%'
                          : ownercardprop && matches1400
                          ? '100%'
                          : ownercardprop && matches1700
                          ? '50%'
                          : ownercardprop && matches1920
                          ? '100%'
                          : ownercardprop
                          ? '50%'
                          : '47%',
                    }}
                  >
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '14px',
                        color: '#585858',
                      }}
                    >
                      {ownercardprop ? (
                        <>
                          <Typography
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                            }}
                          >
                            <span>{moneyicon()}</span>{' '}
                            <span
                              style={{
                                fontFamily: 'Poppins',
                                fontSize: '14px',
                                color: '#585858',
                                fontWeight: '400',
                              }}
                            >
                              Last Sold :
                              {ownerExpandData?.data?.lastSold != null ? (
                                <span
                                  style={{
                                    fontFamily: 'Poppins',
                                    fontSize: matches1000
                                      ? '14px'
                                      : matches1100
                                      ? '12px'
                                      : '14px',
                                    color: '#585858',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {`$${numberWithCommas(
                                    ownerExpandData?.data?.lastSold
                                  )}`}
                                </span>
                              ) : (
                                <span
                                  style={{
                                    fontFamily: 'Poppins',
                                    fontSize: matches1000
                                      ? '14px'
                                      : matches1100
                                      ? '12px'
                                      : '14px',
                                    color: '#585858',
                                  }}
                                >
                                  -
                                </span>
                              )}
                            </span>
                          </Typography>
                        </>
                      ) : (
                        <span
                          style={{
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            color: '#585858',
                            fontWeight: matchessm ? 400 : 500,
                          }}
                        >
                          Property Interest
                        </span>
                      )}
                    </Typography>
                  </Grid>
                  <Grid
                    sx={{
                      width:
                        ownercardpopover && matches530
                          ? '100%'
                          : ownercardpopover && matches650
                          ? '50%'
                          : ownercardprop && matches1400
                          ? '100%'
                          : ownercardprop && matches1700
                          ? '50%'
                          : ownercardprop && matches1920
                          ? '100%'
                          : ownercardprop && !matches1920
                          ? '50%'
                          : '',
                      mt:
                        ownercardpopover && matches530
                          ? '20px'
                          : ownercardpopover && matches650
                          ? ''
                          : ownercardprop && matches1400
                          ? '20px'
                          : ownercardprop && matches1920 && !matches1700
                          ? '20px'
                          : '',
                    }}
                  >
                    {/* {ownercardprop ? (
                      <>
                        {currency()} &nbsp;{" "}
                        <span> Sold Date 14 April 2000</span>
                      </>
                    ) : (
                      <AvgerageRating />
                    )} */}
                    {ownercardprop ? (
                      <>
                        <Typography
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                          }}
                        >
                          <span>{currency()} </span>{' '}
                          <span
                            style={{
                              fontFamily: 'Poppins',
                              fontSize: '14px',
                              color: '#585858',
                              fontWeight: '400',
                            }}
                          >
                            {' '}
                            Sold Date :
                            {ownerExpandData?.data?.soldDate != null ? (
                              <span
                                style={{
                                  fontFamily: 'Poppins',
                                  fontSize: matches1000
                                    ? '14px'
                                    : matches1100
                                    ? '12px'
                                    : '14px',
                                  color: '#585858',
                                  fontWeight: 'bold',
                                }}
                              >
                                {moment(ownerExpandData?.data?.soldDate).format(
                                  'DD-MM-YYYY'
                                )}
                              </span>
                            ) : (
                              <span
                                style={{
                                  fontFamily: 'Poppins',
                                  fontSize: matches1000
                                    ? '14px'
                                    : matches1100
                                    ? '12px'
                                    : '14px',
                                  color: '#585858',
                                }}
                              >
                                -
                              </span>
                            )}
                          </span>
                        </Typography>
                      </>
                    ) : expandData?.data?.propertyInterest == 0 ? (
                      <Box
                        sx={{
                          marginLeft: '25px',
                        }}
                      >
                        -
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          marginLeft: '-10px',
                        }}
                      >
                        <CircularProgressWithProfile
                          value={expandData?.data?.propertyInterest}
                        />
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-around',
                  // alignItems: "flex-start",
                  padding: '8px 20px',
                  borderRadius: '8px',
                  minHeight: ownercardprop && matches1000 && '196px',
                  // width:  window.innerWidth <= 1550 ? "70%" : "48%",
                  width:
                    ownercardpopover && matches650
                      ? '100%'
                      : ownercardpopover && matches870
                      ? '50%'
                      : matches1000
                      ? '100%'
                      : matches1400
                      ? '50%'
                      : isLg || isMd || isSm || isXs || matches1700
                      ? '100%'
                      : '50%',
                  // width:window.innerWidth <= 1300 ? "100%": '50%',
                  // height: isMd || isSm || isXs ? "auto" : "156px",
                  // border: "1px solid blue",
                  background: '#F8F8F8',
                  gap: '10px',
                }}
              >
                <Stack
                  direction={'column'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  sx={{ width: '40%' }}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '14px',
                      color: '#585858',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {ownercardprop ? 'Ready to Sell' : 'Buyer match'}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      marginBottom: '15px',
                    }}
                  >
                    <CircularProgressexpanded
                      value={
                        ownercardprop ? 0 : expandData?.data?.profileActivity
                      }
                    />
                  </Box>
                </Stack>
                <Stack
                  direction={'column'}
                  justifyContent={'space-evenly'}
                  alignItems={'center'}
                >
                  {window.innerWidth > 960 && <Verticalline />}
                </Stack>
                <Stack
                  direction={'column'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '14px',
                      color: '#585858',
                    }}
                  >
                    Activity Summary
                  </Typography>
                  <Grid
                    container
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-around',
                      width: '100%',
                      // height: isMd || isSm || isXs ? "auto" : "119px",
                      // border: "1px solid black",
                      background: '#F8F8F8',
                      alignItems: 'center',
                    }}
                  >
                    <Grid
                      sx={{
                        display: 'flex',
                        flexDirection:
                          opendialog || openbuyermatch
                            ? 'column'
                            : ownercardpopover && matches870
                            ? 'column'
                            : popover && matches500
                            ? 'column'
                            : popover && matches650
                            ? 'row'
                            : popover && !matches650
                            ? 'column'
                            : matches1000
                            ? 'row'
                            : matches1400
                            ? 'column'
                            : matches1450 && show
                            ? 'column'
                            : isLg || isMd || isSm || isXs || matches1700
                            ? 'row'
                            : matches1800
                            ? 'column'
                            : matches1850 && show
                            ? 'column'
                            : 'row',
                        // gap: show ? "20px" : "20px",
                        gap: matches1400 ? '5px' : '20px',
                        // marginLeft: show ? "10%" : "none",
                        marginLeft: 'none',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '8px',
                          width: '111px',
                          height: '59px',
                          background: 'rgba(108, 42, 210, 0.1)',
                          textAlign: 'center',
                        }}
                      >
                        <Typography
                          sx={{
                            ...poppins500,
                            fontSize: '16px',
                            color: '#6C2AD2',
                          }}
                        >
                          {/* {ownercardprop ? "92 Days" : "2 Days"} */}
                          {ownercardprop
                            ? '0 Days'
                            : `${
                                expandData?.data?.inspectionDaysDifference || 0
                              }`}
                        </Typography>
                        <Typography
                          sx={{
                            ...poppins400,
                            fontSize: '10px',
                            color: '#666666',
                          }}
                        >
                          {ownercardprop
                            ? 'Since Last Contact'
                            : 'Since First Inspection'}
                        </Typography>
                      </Box>
                      {/* <Typography>
                        <Button
                          // variant="contained"
                          sx={{
                            ...poppins400,
                            fontSize: "12px",
                            lineHeight: "18px",
                            color: "#6C2AD2",
                            bgcolor: "rgba(108, 42, 210, 0.1)",
                          }}
                          onClick={() => setExpandFeedback(!expandFeedback)}
                        >
                          Feedback
                        </Button>
                      </Typography> */}
                      <Box
                        sx={{
                          display: 'flex',
                          height: '59px',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          borderRadius: '8px',
                          width: '111px',
                          backgroundColor: 'rgba(47, 205, 255, 0.12)',
                        }}
                      >
                        <Typography
                          sx={{
                            ...poppins500,
                            fontSize: '16px',
                            color: ' #2FCDFF',
                          }}
                        >
                          {/* {ownercardprop ? "6" : "12"} */}
                          {ownercardprop
                            ? '0'
                            : `${expandData?.data?.totalActivities || 0}`}
                        </Typography>
                        <Typography
                          sx={{
                            ...poppins400,
                            fontSize: '10px',
                            color: '#666666',
                          }}
                        >
                          {ownercardprop
                            ? 'Total Follow Up'
                            : 'Total Activities'}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Stack>
              </Grid>
            </Stack>
          </Grid>
          {!ownercardprop && (
            <Grid
              container
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                // border: "1px solid blue",
                padding: matchessm ? '10px 20px' : '0px',
                width: '100%',
                // height: "50px",
                justifyContent: 'space-between',
                // marginTop:  window.innerWidth <= 1550 ? "200px" : "0px"
              }}
            >
              <Grid
                item
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  // gap: "10px",
                  alignItems: 'flex-start',
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      ...poppins500,
                      fontSize: '14px',
                      color: matchessm ? '#26344E' : '#585858',
                    }}
                  >
                    Offer Terms{' '}
                  </Typography>
                </Box>

                {expandData?.data?.noOfOffers !== 0 && (
                  <Typography
                    sx={{
                      ...poppins500,
                      fontSize: '10px',
                      color: '#FFFFFF',
                      background:
                        expandData?.data?.isConditional == 1
                          ? 'rgba(237, 11, 11, 0.6)'
                          : '#10D35E',
                      borderRadius: '5px',
                      mt: 1,
                      p: '4px 8px',
                    }}
                  >
                    {/* Conditional */}
                    {expandData?.data?.isConditional == 1
                      ? 'Conditional'
                      : 'Unconditional'}
                  </Typography>
                )}
              </Grid>

              <Grid
                item
                sx={{ display: 'flex', flexDirection: 'row', gap: '15px' }}
              >
                <Box>
                  <LeftArrow />
                </Box>
                <Box>
                  <DownArrowIcon />
                </Box>
              </Grid>
            </Grid>
          )}
          {!ownercardprop && (
            <Grid
              container
              xs={12}
              sm={12}
              lg={12}
              sx={{
                display: 'flex',
                // flexDirection: isMd? "column" :"row",
                // justifyContent: isLg ? "center": "space-between",
                gap: '10px',
                // height: "92.77px",
                // width: "97%",
                width: '100%',
              }}
            >
              {makeOfferListArray?.length > 0 &&
              expandData?.data?.offerTerms?.length > 0 ? (
                makeOfferListArray?.map((item, index) => {
                  let show = false;
                  if (expandData?.data?.offerTerms?.length > 0) {
                    expandData?.data?.offerTerms?.map((value) => {
                      if (item?.conditionSubjectCode === value?.conditionCode) {
                        show = true;
                      }
                    });
                  }
                  const offerTerm = expandData?.data?.offerTerms?.find(
                    (value) =>
                      value?.conditionCode === item?.conditionSubjectCode
                  );
                  const isAdditionalCondition =
                    item?.conditionSubjectCode === 'SubtoAdd001';

                  return (
                    <AdditionalConditionTooltip
                      key={`${item?.conditionSubjectCode}-${index}`}
                      comment={offerTerm?.additionalCondition}
                      disabled={!isAdditionalCondition}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        lg={2}
                        sx={{
                          display: 'flex',
                          padding: window.innerWidth <= 1400 ? '5px' : '10px',
                          flexDirection: 'column',
                          width:
                            window.innerWidth < 1400 || window.innerWidth < 600
                              ? '100%'
                              : '19.36px',
                          height: 'auto',
                          background: '#FFFFFF',
                          border: '1px solid #DFDFDF',
                          borderRadius: '8px',
                          position: 'relative',
                          cursor: isAdditionalCondition ? 'pointer' : 'default',
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            {item?.conditionSubjectCode === 'SubtoDep001' ? (
                              <Typography
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  fontSize: '26px',
                                }}
                              >
                                {item?.conditionSubjectFile}%
                              </Typography>
                            ) : item?.conditionSubjectCode ===
                              'SubtoSettle001' ? (
                              <Typography
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  fontSize: '26px',
                                }}
                              >
                                {item?.conditionSubjectFile}
                              </Typography>
                            ) : (
                              <Typography
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                <img
                                  src={item?.conditionSubjectFile}
                                  alt="icon"
                                  height={40}
                                />
                              </Typography>
                            )}
                            {show && (
                              <Typography
                                sx={{
                                  position: 'absolute',
                                  top: '0px',
                                  right: '0px',
                                  padding: '5px',
                                }}
                              >
                                <CheckCircleIcon sx={{ color: '#3097cf' }} />
                              </Typography>
                            )}
                          </Typography>
                          <Box
                            sx={{
                              textAlign: 'center',
                              marginTop: '10px',
                            }}
                          >
                            <Typography
                              sx={{
                                ...poppins400,
                                fontSize:
                                  window.innerWidth <= 800 ? '9px' : '12px',
                                color: '#666666',
                              }}
                            >
                              {item?.conditionSubjectValue}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    </AdditionalConditionTooltip>
                  );
                })
              ) : (
                <Grid
                  xs={12}
                  sm={12}
                  lg={12}
                  sx={{
                    textAlign: 'center',
                    fontFamily: 'poppins',
                    color: '#585858',
                    alignItems: 'center',
                    fontWeight: 400,
                    fontSize: matchessm ? '14px' : 'auto',
                  }}
                >
                  The buyer has not requested additional offer terms
                </Grid>
              )}
              <Grid
                item
                xs={12}
                sm={12}
                lg={1}
                sx={{
                  marginLeft: 'auto',
                  display: 'flex',
                  justifyContent: 'end',
                  alignItems: 'end',
                }}
              >
                <Typography>
                  <Box>
                    <Typography>
                      <Box aria-describedby={id} onClick={handleClicke}>
                        <Button
                          onClick={handleClicke}
                          sx={[
                            menuitemfont,
                            {
                              ...poppins500,
                              fontSize: '12px',
                              // boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.15)",
                              border: '1px solid #6C2AD2',
                              '.MuiOutlinedInput-notchedOutline': { border: 0 },
                              outline: 'none',
                              color: '#112347',
                              height: '30px',
                              width: '83px',
                              borderRadius: '5px',
                              textTransform: 'none',
                              whiteSpace: 'nowrap',
                              alignItems: 'center',
                              padding: '10px',
                            },
                          ]}
                        >
                          Action &nbsp;
                          <SelectDownIcon />
                        </Button>
                      </Box>
                      <Popover
                        id={id}
                        open={openn}
                        anchorEl={anchorEl}
                        onClose={handleClosee}
                        PaperProps={{
                          style: {
                            boxShadow: 'none',
                            border: '1px solid #D9D9D9',
                            borderRadius: '4px',
                            minWidth: '84px',
                          },
                        }}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'left',
                        }}
                      >
                        <Typography>
                          <MenuItem
                            onClick={handleClosee}
                            value={10}
                            sx={{
                              ...poppins500,
                              fontSize: '12px',
                              color: '#112347',
                              alignItems: 'center',
                              justifyContent: 'left',
                            }}
                          >
                            Action
                          </MenuItem>
                        </Typography>
                        <Typography>
                          <MenuItem
                            onClick={handleClosee}
                            value={10}
                            sx={{
                              ...poppins500,
                              fontSize: '12px',
                              color: '#112347',
                              alignItems: 'center',
                              justifyContent: 'left',
                            }}
                          >
                            Twenty
                          </MenuItem>
                        </Typography>
                        <Typography>
                          <MenuItem
                            onClick={handleClosee}
                            value={10}
                            sx={{
                              ...poppins500,
                              fontSize: '12px',
                              color: '#112347',
                              alignItems: 'center',
                              justifyContent: 'left',
                            }}
                          >
                            Thirty
                          </MenuItem>
                        </Typography>
                      </Popover>
                    </Typography>
                  </Box>

                  {/* <Select
                  sx={{
                    color: "#6C2AD2",
                    border: "1px solid #6C2AD2",
                    marginTop: expandData?.data?.offerTerms?.length > 0 ? "77px" : "0",
                    // width: "83px",
                    height: "30px",
                    ...poppins500,
                    fontSize: "12px",
                    width: window.innerWidth < 1000 || window.innerWidth < 600 ? "50%" : "none",
                    // marginLeft:"12px"
                    }}
                  size="medium"
                  value="10"
                  style={{
                    padding: "0px",
                  }}
                  onChange={() => {}}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={10}>Action</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem>
                </Select> */}
                </Typography>
              </Grid>
            </Grid>
          )}

          {/* confirmation popup for adding pipline property */}
          <Dialog
            open={openMovePipelineConfirm}
            fullWidth={'lg'}
            PaperProps={{
              sx: {
                borderRadius: '5px',
                minWidth: matchessm ? '95%' : '400px',
                boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
                padding: matchessm ? '30px 20px' : '20px',
              },
            }}
          >
            <Grid container height={'100%'}>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchessm ? '10px' : '14px',
                    color: '#666666',
                  }}
                >
                  {/* {item?.propertyAddress?.streetName} */}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                display={'flex'}
                alignItems={'center'}
                padding={'12px 0px 15px 0'}
              >
                <Pendingwarning />
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: matchessm ? '16px' : '24px',
                    paddingLeft: '12px',
                  }}
                >
                  Move to Pipeline?
                </Typography>
              </Grid>
              <Grid item md={12}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                    marginTop: '50px',
                  }}
                >
                  Do you want to Move this property{' '}
                  <Typography
                    component="span"
                    sx={{ fontWeight: 'bold', color: '#000' }}
                  >
                    {Address}
                  </Typography>{' '}
                  to{' '}
                  <Typography
                    component="span"
                    sx={{ fontWeight: 'bold', color: '#000' }}
                  >
                    {selectedPipeCategory?.categoryName}
                  </Typography>
                  ?
                </Typography>
              </Grid>

              <Grid
                item
                container
                direction="row"
                justifyContent={'flex-end'}
                gap={2}
                marginTop={matchessm ? '15px' : 5}
              >
                <Grid item>
                  <Button
                    onClick={() => {
                      setOpenMovePipelineConfirm(false);
                      handleCloseSuboptionPopover();
                    }}
                    variant="outlined"
                    style={{
                      padding: matchessm ? '6px 23px' : '10px 39px',
                      width: '100%',
                      height: matchessm ? '35px' : '41px',
                      fontSize: matchessm ? '12px' : '14px',
                      color: '#666666',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      border: '1px solid rgba(17, 35, 71, 0.1)',
                      borderRadius: '5px',
                      textTransform: 'capitalize',
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid
                  item
                  sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <Button
                    onClick={handleConfirmMove}
                    variant="outlined"
                    style={{
                      padding: matchessm ? '6px 23px' : '10px 39px',
                      minWidth: '140px',
                      height: matchessm ? '35px' : '41px',
                      fontSize: matchessm ? '12px' : '14px',
                      color: '#FFFFFF',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      background: '#4CA4D6',
                      borderRadius: '5px',
                      textTransform: 'capitalize',
                    }}
                  >
                    Move
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Dialog>
        </Grid>
      )}

      {/* {propertyValue === 0 && ( */}
      {/* {!isSmall && ( */}
      <ExpendedCardDocumentation
        propertyValue={propertyValue}
        show={show}
        buyerId={buyerId}
        activitywidth={activitywidth}
        rowData={rowData}
        ownercardprop={ownercardprop}
        marketShow={marketShow}
        proid={proid}
        proUniqueId={proUniqueId}
        userEmail={userEmail}
        userType={userType}
        selectedProperty={address}
        buyerpropertylist={buyerpropertylist}
        Address={Address}
        getdata={getdata}
        fromSearch={fromSearch}
        catSelected={catSelected}
        noteSelected={noteSelected}
        taskId={taskId}
        taskBinderId={taskBinderId}
        isPipelineManagement={isPipelineManagement}
      />
      {/* )} */}
    </>
  );
};
